<template>
  <v-card class="bank-account-transactions-card" :class=classes>
    <v-card-title>      
      <div class="back_url mr-auto">
        <v-btn v-if="currentCompany" icon @click="$router.push({name: 'bank-accounts', params: {'company_id': currentCompany.id}})">
          <AppIcon :src="icons.backArrow" :size="29" />
        </v-btn>        
        <span class="font-weight-bold primary_blue--text">VOLVER LISTADO</span>
      </div>        
      <div v-if="currentBankAccount && got_feature('feature_use_different_currencies_in_banks') && currentBankAccount && currentBankAccount.currency && !currentBankAccount.currency.includes('EUR')" class="back_url mr-auto">
        <span><strong>Divisa </strong> <span class="currency">{{ currentBankAccount.currency }} </span></span>
      </div>
      <div class="transactions-card-title">
        <span class="primary--text py-1 ml-2">Transacciones cuenta:</span>
        <span class="ml-2">{{ currentBankAccount.iban }}</span>
      </div>        

      <div class="ml-6">

        <JobProgress v-if="currentBankAccount"
          v-model="uploadFileTransactionsJobState"
          v-on:done="uploadFileTransactionsJobDone()"
          v-on:error="uploadFileTransactionsJobError()"
          :job_id="uploadFileTransactionsJobId" class="progress_circular">
          <template v-slot:progress>
            <v-progress-circular
                v-if="uploadFileTransactionsJobState==='running'"
                indeterminate           
                color="primary"
                class="progress_circle"
            ></v-progress-circular>
          </template>
          <template v-slot:done>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  @click="openUploadExcelPopUp()"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  icon 
                  >
                  <AppIcon :src="icons.uploadFile" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                </v-btn>
              </template>
              <span>Subir documento con movimientos</span>
            </v-tooltip>
          </template>
          <template v-slot:error>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  @click="openUploadExcelPopUp()"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  icon 
                  >
                  <AppIcon :src="icons.uploadFile" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                </v-btn>
              </template>
              <span>Subir documento con movimientos</span>
            </v-tooltip>
          </template>
        </JobProgress>

        <v-tooltip top v-if="currentBankAccount && got_feature('feature_upload_bank_transactions_electron') && permission.can_write && !got_feature('feature_bank_csv')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              @click="dialog_launch_upload_transactions_electron = true" 
              v-bind="attrs" 
              v-on="on" 
              color="primary" 
              icon 
              :loading="loading_launch_operation_upload"
            >
              <AppIcon :src="icons.importBank" :size="29" :colorMap="{ '060647': 'primary_blue' }" />
            </v-btn>
          </template>
          <span>Cargar movimientos del programa contable</span>
        </v-tooltip>
        <v-tooltip top v-if="currentBankAccount">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="toggleShowFilters()" v-bind="attrs" v-on="on" color="primary" icon>
              <AppIcon :src="icons.filters" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
            </v-btn>
          </template>
          <span>Filtros de búsqueda</span>
        </v-tooltip>
        <JobProgress v-model="uploadProviderJobState" v-on:done="uploadProviderJobDone(true)" :job_id="uploadProviderJobId" class="progress_circular">
          <template v-slot:progress>
              <v-progress-circular
                  v-if="uploadProviderJobState==='running'"
                  indeterminate           
                  color="primary"
                  class="progress_circle"
              ></v-progress-circular>
          </template>
          <template v-slot:done>
            <v-tooltip top v-if="['gocardless', 'enablebanking', 'enablebanking_sandbox', 'afterbanks'].includes(currentBankAccount.kind)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  @click="showUploadDialogOrDirectUpload()"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  icon 
                  >
                  <AppIcon :src="icons.downloadAuto" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                </v-btn>
              </template>
              <span>Descargar movimientos</span>
            </v-tooltip>
          </template>
        </JobProgress>


        <!-- <JobProgress v-model="importEffectsJobState" v-on:done="importEffectsJobDone(true)" :job_id="importEffectsJobId" class="progress_circular">
          <template v-slot:progress>
              <v-progress-circular
                  v-if="importEffectsJobState==='running'"
                  indeterminate           
                  color="primary"
                  class="progress_circle"
              ></v-progress-circular>
          </template>
          <template v-slot:done>
            <v-tooltip top v-if="currentBankAccount && got_feature('feature_can_use_payable_or_receivable_effects') && false">
              <template v-slot:activator="{ on, attrs }">                
                <v-btn 
                  @click="dialog_import_effects = true"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  icon 
                  >
                  <AppIcon :src="icons.syncEffects" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>                
                </v-btn>
              </template>
              <span>Sincronizar efectos Inmatic</span>
            </v-tooltip>
          </template>
        </JobProgress> -->
        <v-tooltip top v-if="currentBankAccount">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="openPopUpConfiguration()" v-bind="attrs" v-on="on" color="primary" icon>
              <AppIcon :src="icons.config" :size="29" :colorMap="{ '060647': 'primary_blue' }" />
            </v-btn>
          </template>
          <span>Configuración</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              @click="toggleShowRules()" 
              v-bind="attrs" 
              v-on="on" 
              color="primary" 
              icon 
            >
              <AppIcon :src="icons.toggleRules" :size="29" v-if="showRules" :colorMap="{ '060647': 'primary_blue' }"/>
              <AppIcon :src="icons.toggleRules2" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
            </v-btn>
          </template>
          <span v-if="showRules">Ocultar reglas</span>
          <span v-else>Mostrar reglas</span>
        </v-tooltip>
      </div>           
    </v-card-title>

    <v-divider></v-divider>

              <v-card-text>
                <v-container>
                  <v-row class="pa-0 ma-0" v-show="showFilters">
                    <!-- Campo Buscador -->
                      <v-col cols="12" sm="3" md="2" lg="2" xl="2">
                        <bank-simple-filters 
                          ref="bankSimpleFilters"                           
                          @updateSimpleFilter="updateFilter"
                          :workWithEffects=workWithEffects
                          >
                        </bank-simple-filters>                        
                      </v-col>  
                      <v-col cols="12" sm="9" md="10" lg="10" xl="10">
                        <app-search-bar
                          :filters="listFilters"
                          @updateObject="updateFilter"
                          @resetAllFilters="removeAllFilt"
                          :pin-state="true"
                          :initial_filters="initial_transactions_filters"
                          :filters_for="'bank_transactions'"
                        />
                      
                      </v-col>

                  </v-row>
                  <v-row class="pa-0 ma-0">
                    <v-col cols="12" class="pa-2 ma-0">
                        <slot name="search_right">
                          <div class="d-flex justify-space-between">
                            <div>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary_blue"
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="addTransactionPopup = true"  
                                  >
                                    <v-icon class="material-symbols-outlined">add_circle</v-icon>
                                  </v-btn>
                                </template>
                                <span> Añadir movimiento manualmente </span>
                              </v-tooltip>
                              <JobProgress v-model="deleteTransactionsJobState" v-on:done="deleteTransactionsJobDone()" :job_id="deleteTransactionsJobId" class="progress_circular">
                                <template v-slot:progress>
                                  <v-progress-circular
                                      v-if="deleteTransactionsJobState==='running'"
                                      indeterminate           
                                      color="primary"
                                      class="progress_circle"
                                  ></v-progress-circular>
                                </template>
                                <template v-slot:done>
                                  <v-tooltip top v-if="permission.can_write">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn 
                                        @click="showDeleteTransactionsPupup = true"
                                        :disabled="!(selectedTransactions.length > 0)"
                                        v-bind="attrs"
                                        v-on="on"
                                        icon 
                                        color="primary_blue"
                                        >
                                        <v-icon class="material-symbols-outlined">delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Eliminar movimientos</span>
                                  </v-tooltip>
                                </template>
                              </JobProgress>
                              <v-tooltip top v-if="permission.can_write">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn 
                                        icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        :disabled="!(selectedTransactions.length > 0)"
                                        @click="markAsTransactionReviewed(true)"
                                        :loading="mark_as_reviewed"
                                        color="primary_blue"
                                      >
                                        <v-icon class="material-symbols-outlined">offline_pin</v-icon>
                                      </v-btn>
                                  </template>
                                  <span> Marcar como revisado </span>
                              </v-tooltip>
                              <v-tooltip top v-if="permission.can_write">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        :disabled="!(selectedTransactions.length > 0)"
                                        @click="markAsTransactionReviewed(false)"
                                        :loading="uncheck_reviewed"
                                        color="primary_blue"
                                      >
                                        <v-icon class="material-symbols-outlined">offline_pin_off</v-icon>
                                      </v-btn>
                                  </template>
                                  <span> Desmarcar revisado </span>
                              </v-tooltip>

                              <v-btn v-if="permission.can_write && workWithEffects"
                                rounded
                                class="text-none" 
                                color="primary"
                                :disabled="!canPuntear"
                                :loading="puntearLoading"
                                @click="checkAmountPuntearTransactionEffects()"
                              >
                                Puntear
                              </v-btn>

                              <v-btn v-if="permission.can_write && workWithEffects"
                                rounded
                                class="text-none ml-1" 
                                color="primary"
                                :disabled="!canDespuntear"
                                :loading="despuntearLoading"
                                @click="despuntearTransactionEffects()"
                              >
                                Despuntear
                              </v-btn>
                            </div>
                            <div>
                              <v-tooltip top v-if="permission.can_write && (userData.is_staff || isLoginas)">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn 
                                    color="primary_blue"
                                    icon 
                                    v-bind="attrs" 
                                    v-on="on"
                                    :disabled="!(selectedTransactions.length > 0)"
                                    @click="updateStateErrorToDraft()"
                                    :loading="loading_update_state_error_draft"
                                    >
                                    <span class="material-symbols-outlined">repartition</span>
                                  </v-btn>
                                </template>
                                <span>Cambiar Estado de Error a Borrador</span>
                              </v-tooltip>
                              <!-- Contabilizado a borrador -->
                              <!-- wip -->
                              <v-tooltip top v-if="permission.can_write"> <!-- userData.is_staff || isLoginas -->
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on"
                                    icon
                                    color="primary_blue"
                                    :disabled="selectedTransactions.length == 0"
                                    :loading="loading_update_state_done_draft"
                                    @click="showRevertDoneToDrafDialog = true"
                                  >
                                    <span class="material-symbols-outlined">draft</span>
                                  </v-btn>
                                </template>
                                <span>Revertir Estado de Contabilizado a Borrador</span>
                              </v-tooltip>
                              <!--------->
                              <v-tooltip top v-if="permission.can_write">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn 
                                    color="primary_blue"
                                    icon 
                                    v-bind="attrs" 
                                    v-on="on"
                                    :disabled="!(selectedTransactions.length > 0)"
                                    @click="updateStateDoneExternally()"
                                    :loading="loading_update_state_done_externally"
                                    >
                                    <span class="material-symbols-outlined">bookmark_added</span>
                                  </v-btn>
                                </template>
                                <span>Cambiar Estado a Contabilizado Externamente</span>
                              </v-tooltip>

                              <v-tooltip top v-if="permission.can_write && currentCompany.companydb_type.value == 'innuva'">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary_blue"
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="!(selectedTransactions.length > 0)"
                                    @click="openUpdateActivityChannel()"
                                    >
                                    <span class="material-symbols-outlined">tune</span>
                                  </v-btn>
                                </template>
                                <span>Configurar Actividad y Canal</span>
                              </v-tooltip>

                              <v-tooltip top v-if="permission.can_write && got_feature('feature_departments') && got_feature('feature_departments_bank')">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary_blue"
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="!(selectedTransactions.length > 0)"
                                    @click="openUpdateDepartment()"
                                    >
                                    <span class="material-symbols-outlined">domain</span>
                                  </v-btn>
                                </template>
                                <span>Configurar Departamento</span>
                              </v-tooltip>

                              <v-tooltip top v-if="permission.can_write">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn 
                                    color="primary_blue"
                                    icon 
                                    v-bind="attrs" 
                                    v-on="on"
                                    :disabled="!(selectedTransactions.length > 0)"
                                    @click="openUpdateMassiveCounterpartPopUp()"
                                    >
                                    <span class="material-symbols-outlined">app_registration</span>
                                  </v-btn>
                                </template>
                                <span>Actualización Contrapartidas Manual</span>
                              </v-tooltip>


                              <JobProgress v-model="asyncJobState" v-on:done="jobDone()" :job_id="asyncJobId" class="progress_circular">
                                <template v-slot:progress>
                                    <v-progress-circular
                                        v-if="asyncJobState==='running'"
                                        indeterminate           
                                        color="primary_blue"
                                        class="progress_circle"
                                    ></v-progress-circular>
                                </template>
                                <template v-slot:done>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn 
                                          color="primary_blue" 
                                          icon 
                                          v-bind="attrs" 
                                          v-on="on"
                                          @click="transferTransactionsPopup = true"
                                          :disabled="totalTransactions.length > 0"
                                        >
                                        <AppIcon :src="icons.transferActive" :size="27" v-if="selectedTransactions.length > 0" :colorMap="{ '060647': 'primary_blue' }"/>
                                            <AppIcon :src="icons.transfer" :size="27" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                        </v-btn>
                                    </template>
                                    <span> Traspasar Transacciones </span>
                                  </v-tooltip>
                                  <v-tooltip top v-if="permission.can_write && !got_feature('feature_bank_csv')">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn                                   
                                        v-bind="attrs" 
                                        v-on="on" 
                                        color="primary_blue" 
                                        icon
                                        :disabled="!(selectedTransactions.length > 0)"
                                        @click="download_csv()"
                                        >
                                        <v-icon class="material-symbols-outlined">vertical_align_bottom</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                  </v-tooltip>
                                  <v-tooltip top v-if="got_feature('feature_can_create_rule_from_transaction') && permission.can_write">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn                                   
                                        v-bind="attrs" 
                                        v-on="on" 
                                        color="primary_blue" 
                                        icon
                                        :disabled="!(selectedTransactions.length > 0)"
                                        @click="generateRuleFromTransactions()"
                                        >
                                        <AppIcon :src="icons.generateRules" :size="16" v-if="(selectedTransactions.length > 0)" :colorMap="{ '060647': 'primary_blue' }"/>
                                        <AppIcon :src="icons.generateRulesDisabled" :size="16" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                      </v-btn>
                                    </template>
                                    <span>Generar reglas</span>
                                  </v-tooltip>
                                  <v-tooltip top v-if="permission.can_write">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn 
                                        color="primary_blue"
                                        class="btn_counterpart" 
                                        icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        :disabled="!(selectedTransactions.length > 0)"
                                        @click="updateCounterpart()"
                                        >
                                        <span class="material-symbols-outlined">restore_page</span>
                                      </v-btn>
                                    </template>
                                    <span>Actualizar Contrapartidas con Reglas</span>
                                  </v-tooltip>
                                </template>
                              </JobProgress>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn 
                                    color="primary_blue" 
                                    icon 
                                    v-bind="attrs" 
                                    v-on="on"
                                    :loading="recalculateBalanceLoading"
                                    @click="recalculateBalance()"
                                    :disabled="totalTransactions.length > 0"
                                  >
                                    <v-icon class="material-symbols-outlined"> calculate </v-icon>
                                  </v-btn>
                                </template>
                                <span>Recalcular saldo</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                      color="primary_blue" 
                                      icon 
                                      v-bind="attrs" 
                                      v-on="on"
                                      @click="show_mismatch = !show_mismatch"
                                      :disabled="totalTransactions.length > 0 || show_possible_duplicates"
                                    >
                                    <v-icon v-if="show_mismatch" class="material-symbols-outlined"> preview </v-icon>
                                    <v-icon v-else class="material-symbols-outlined"> preview_off </v-icon>
                                    </v-btn>
                                </template>
                                <span v-if="!show_mismatch"> Mostrar descuadres </span>
                                <span v-else> Ocultar descuadres </span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                      color="primary_blue" 
                                      icon 
                                      v-bind="attrs" 
                                      v-on="on"
                                      @click="refreshListTransactions()"
                                      :loading="loading_list"
                                    >
                                    <v-icon class="material-symbols-outlined">refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span> Actualizar </span>
                              </v-tooltip>
                              
                              <v-btn v-if="!got_feature('feature_bank_csv') && permission.can_write"
                                rounded
                                class="text-none ml-3" 
                                color="primary"
                                :disabled="!(selectedTransactions.length > 0)"
                                :loading="contabilizarLoading"
                                @click="contabilizar()"
                              >
                                Contabilizar
                              </v-btn>
                              <v-btn v-if="got_feature('feature_bank_csv') && permission.can_write"
                                rounded
                                class="text-none ml-3"
                                color="primary"
                                :disabled="!(selectedTransactions.length > 0)"
                                :loading="contabilizarLoading || asyncJobState==='running'"
                                @click="download_csv()"
                                >
                                Descargar
                              </v-btn>
                            </div>
                          </div>
                        </slot>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :items="transactions_list"
                    :items-per-page="limit"
                    :headers="transactions_headers"
                    fixed-header
                    :show-select="showSelectTransactions"
                    v-model="selectedTransactions"
                    @input="emitUpdateTr()"
                    :loading="loading_list"
                    :single-expand="true"
                    :expanded.sync="row_expanded"
                    show-expand
                    item-key="id"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 50, 100, 200, 500],
                      'items-per-page-text': 'Transacciones por página:',
                    }"
                    :height="tableHeight"
                    :item-class="itemRowBackground"
                    @update:items-per-page="changeLimit"
                    @update:page="changeOffset"
                    :page="pageTransactions"
                    :server-items-length="totalTransactions"                           
                  >                 
                  
                  <!-- Header Personalizables -->
                  <template v-for="header in transactions_headers_no_expand" v-slot:[`header.${header.value}`]>
                    <span :key="`header-text-${header.value}`" tabindex="0" v-if="header.text == 'Importe(EUR)' && got_feature('feature_use_different_currencies_in_banks')">
                      Importe<span class="light__header">(EUR)</span>
                    </span>
                    <v-tooltip :key="`header-punteado-${header.value}`" top v-else-if="header.value == 'punteado'" class="pa-0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon 
                          color="green"
                          size="18px"
                          v-bind="attrs" 
                          v-on="on"
                          class="material-symbols-rounded">offline_pin
                        </v-icon>
                      </template>
                      <span>Revisado</span>
                    </v-tooltip>
                    <v-tooltip :key="`header-contains-effects-${header.value}`" top v-else-if="header.value == 'contains_effects'">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" 
                          v-on="on"
                          class="square-icon-text red-icon white--text">
                          P
                        </div>
                      </template>
                      <span>Efecto punteado</span>
                    </v-tooltip>
                    <div :key="`header-default-contrapartida-${header.value}`" class="square-icon-text orange-icon white--text" v-else-if="header.value == 'default_contrapartida'">
                      A
                    </div>
                    <span :key="`header-else-${header.value}`" tabindex="0" v-else>
                      {{ header.text }}
                    </span>
                  </template>

                  <template v-for="header in transactions_headers_no_expand" v-slot:[`item.${header.value}`]="{ item }">
                    <span class="font-color" :key="`item-${item.id}-${header.value}`">
                      <slot v-if="header.value == 'bookingDate'" :name="header.value" v-bind="item">
                        {{ changeFormat(item[header.value]) }} 
                      </slot>
                      <slot v-else-if="header.value == 'contrapartida'" :name="header.value" v-bind="item">
                        <div class="d-flex align-center">

                          <template v-if="!item.contrapartida || item.contrapartida.length <= 1">
                            <div  class="d-flex align-center counterpart__field__with__effect" v-if="got_feature('feature_can_use_payable_or_receivable_effects') && workWithEffects">
                              <v-tooltip top v-if="permission.can_write">
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-on="on" v-bind="attrs">
                                    <div class="btn-switch_counterpart mr-1"
                                      :class="item.conciliation_state != 'draft' || !permission.can_write ? 'disabled': ''"
                                      v-on:click="switchCounterpartKind(item)"
                                      :disabled="item.conciliation_state != 'draft' || !permission.can_write"
                                      x-small
                                      >

                                      <div v-if="item.contrapartida[0].kind == 'account'" class="pa-0 ma-0 d-flex mr-1">
                                        <img v-if="item.conciliation_state == 'draft'" src="../assets/bank-account-switch.svg"/>
                                        <img v-else src="../assets/bank-account-switch-disabled.svg"/>
                                      </div>

                                      <span class="text__switch" :class="item.conciliation_state == 'draft'? 'primary--text': 'text_readonly'">{{ item.contrapartida[0].kind=='account'? 'C':'F' }} </span>

                                      <div v-if="item.contrapartida[0].kind == 'effect'" class="pa-0 ma-0 d-flex ml-1">
                                        <img v-if="item.conciliation_state == 'draft'" src="../assets/bank-effect-switch.svg"/>
                                        <img v-else src="../assets/bank-effect-switch-disabled.svg"/>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                <span v-if="item.contrapartida[0].kind=='account'">Cuenta</span>
                                <span v-else>Efecto</span>
                              </v-tooltip>
                              <div v-if="!show_counterpart_fields[item.id]" 
                                @click="showCounterpartField(item)">
                                {{ item.contrapartida[0].account }}
                              </div>
                              <template v-else>
                                <ContrapartidaField
                                  v-if="item.contrapartida[0].kind == 'account'"
                                  :readonly="item.conciliation_state != 'draft' || !permission.can_write"
                                  :items="accounts"
                                  v-model="item.contrapartida[0].account"
                                  @input="setDirty(item.id)"
                                  @change="setDirtyAndSave(item)"
                                  @get-values="getValues"
                                  @reset-items="resetItems"
                                  :num_digits="currentCompany.num_digits"
                                  :autofocus="true"
                                ></ContrapartidaField>

                                
                                <v-combobox                                
                                  v-else
                                  :items="filteredEffectsCounterpart"
                                  :readonly="item.conciliation_state != 'draft' || !permission.can_write"
                                  :item-value="item => item.account + '-' + item.code"                                
                                  item-text="account"
                                  v-model="item.contrapartida[0].account"
                                  class="counterpart_kind align__right"
                                  append-icon=""
                                  :hide-details="true"
                                  @change="changeEffect(item)"
                                  @input="setDirty(item.id)"
                                  @input.native="myNativeInputEffectCounterpart($event, item)"
                                  @click="myNativeInputEffectCounterpart($event, item)"
                                  @blur="resetEffectsCounterpartItems"
                                  :autofocus="true"
                                  return-object
                                  no-filter
                                >
                                  <template v-slot:item="data">
                                    {{ `${data.item.account} - (${data.item.amount}€) - (${data.item.date}) - (${data.item.code}) - ${data.item.concept}`}}
                                  </template>
                                </v-combobox>
                              </template>
                            </div>
                            <template v-else>
                              <div v-if="!show_counterpart_fields[item.id]" 
                                @click="showCounterpartField(item)">
                                {{ item.contrapartida[0].account }}
                              </div>
                              
                              <ContrapartidaField
                                v-else
                                :readonly="item.conciliation_state != 'draft' || !permission.can_write"
                                style="max-width:100px;"
                                :items="accounts"
                                v-model="item.contrapartida[0].account"
                                @input="setDirty(item.id)"
                                @change="setDirtyAndSave(item)"
                                @get-values="getValues"
                                @reset-items="resetItems"
                                :num_digits="currentCompany.num_digits"
                                :autofocus="true"
                                ></ContrapartidaField>                              
                            </template>
                            <div
                                v-if="item.contrapartida && permission.can_write"                    
                                class="btn-table-counterpart ml-1" 
                                icon outlined 
                                @click="openCounterpartsDialog(item)"                            
                              >                              
                                <AppIcon :src="icons.btnPlus" :size="29" v-if="item.conciliation_state == 'draft'" :colorMap="{ '060647': 'primary_blue' }"/>
                                <AppIcon :src="icons.btnEye" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                            </div>
                          </template>
                          <template v-else>
                            <div class="grey--text">{{ item.contrapartida.length }} contrapartidas</div>
                            <div                               
                              class="btn-table-counterpart ml-1" 
                              icon outlined 
                              @click="openCounterpartsDialog(item)"                            
                            >                              
                              <AppIcon :src="icons.btnPencil" :colorMap="{ '060647': 'primary_blue' }" :size="29" v-if="item.conciliation_state == 'draft' && permission.can_write" />
                              <AppIcon :src="icons.btnEye" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                          </div>
                          </template>
                        </div>
                      </slot>
                      <slot v-else-if="header.value == 'conciliation_state'" :name="header.value" v-bind="item">
                        <div class="d-flex align-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                @contextmenu.prevent="copyIdToClipboard(item.id)"
                                v-bind="attrs"
                                v-on="on"
                                style="cursor: context-menu;"
                              >
                                {{ displayConciliationState(item) }}
                              </div>
                            </template>
                            <span>Click derecho para copiar ID</span>
                          </v-tooltip>
                          <v-btn
                            v-if="item.conciliation_state === 'error' && item.error"
                            icon small class="mx-1"
                            @click.stop="showErrorDialog(item)"
                          >
                            <v-icon color="red" small>mdi-alert</v-icon>
                          </v-btn>
                        </div>
                      </slot>
                      <slot v-else-if="header.value == 'concept'" :name="header.value" v-bind="item">
                        <v-tooltip bottom :disabled="item.contrapartida.length < 2">
                          <template v-slot:activator="{on}">
                            <input style="min-width:320px;"
                              v-model="item['concept']"
                              @input="changeTransactionConcept(item)"
                              @change="setDirtyAndSave(item)"
                              :readonly="item.conciliation_state != 'draft' || !permission.can_write || item.contrapartida.length > 1"
                              v-on="on"
                            /> 
                          </template>
                          Múltiples contrapartidas, puede haber conceptos diferentes en cada una
                        </v-tooltip>
                      </slot>
                      <slot v-else-if="header.value === 'default_contrapartida'" :name="header.value" v-bind=item>
                        <span v-if="item[header.value] == false">
                          <v-icon class="icon-16" color="#F7BC25">mdi-circle</v-icon>
                        </span>                     
                      </slot>
                      <slot v-else-if="header.value === 'contains_effects'" :name="header.value" v-bind=item>
                        <span v-if="item[header.value] == true">
                          <v-icon class="icon-16" color="#F36C0B">mdi-circle</v-icon>
                        </span>                     
                      </slot>
                      <slot v-else-if="header.value === 'punteado'" :name="header.value" v-bind=item>
                        <span v-if="item[header.value] == true">
                          <v-icon class="icon-16" color="var(--v-success-base)">mdi-checkbox-marked-circle</v-icon>
                        </span>
                      </slot>
                      <slot v-else-if="header.value === 'amount' || header.value=='calculated_balance'" :name="header.value" v-bind=item>
                        <div class="text-right">
                          {{ item[header.value] }}
                        </div>
                      </slot>
                      <slot v-else-if="header.value == 'original_amount' && got_feature('feature_use_different_currencies_in_banks')" :name="header.value" v-bind=item>
                        <div class="text-right">
                          {{ item['additional_information'].original_amount }}
                        </div>
                      </slot>
                      <slot v-else-if="header.value == 'analytics' && got_feature('feature_project_bank_counterpart')" :name="header.value" v-bind=item>
                        <div class="text-center">
                          {{ getAnalyticsCode(item.contrapartida) }} <!-- get analytics code -->
                        </div>
                      </slot>
                      <slot v-else :name="header.value" v-bind="item">
                        {{ item[header.value] }} 
                      </slot>
                    </span>
                  </template>
                  
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex align-center">
                      
                      <v-tooltip top v-if="permission.can_write">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            class="btn-table-transaction"
                            :class="isDirty(item.id) ? 'btn-pointer' : ''"  
                            @click="saveTransaction(item)"                            
                            v-bind="attrs" 
                            v-on="on" 
                            color="primary"                                                        
                            >
                            <AppIcon :src="icons.saveDisabled" :size="24" v-if="!isDirty(item.id)" :colorMap="{ '060647': 'primary_blue' }"/>
                            <AppIcon :src="icons.save" :size="24" v-else-if="isDirty(item.id)" :colorMap="{ '060647': 'primary_blue' }"/>
                            <v-progress-circular v-else :size="24" :width="2" indeterminate></v-progress-circular>                            
                          </div>                          
                        </template>
                        <span>Guardar</span>
                      </v-tooltip>

                      <v-tooltip top v-if="got_feature('feature_can_create_rule_from_transaction') && permission.can_write">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            class="btn-table-transaction btn-pointer" 
                            @click="generateRule(item)"
                            v-bind="attrs" 
                            v-on="on" 
                            color="primary"                                                       
                            >                            
                            <AppIcon :src="icons.generateRule" :size="24" v-if="!loading_generate_rule_transactions[item.id]" :colorMap="{ '060647': 'primary_blue' }"/>
                            <v-progress-circular v-else indeterminate></v-progress-circular>
                          </div>

                        </template>
                        <span>Generar regla</span>
                      </v-tooltip>

                      <template v-if="permission.can_write">
                        <v-tooltip top v-if="item.conciliation_state == 'draft' && item.amount > 0 && item.contrapartida.map((c)=>c.account).some(ac => bank_account_list.includes(ac))">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="btn-table-transaction btn-pointer" 
                              color="primary"                              
                              v-bind="attrs" 
                              v-on="on"
                              @click="showInformationDialog(item)">
                              <v-icon color="primary">mdi-information-variant</v-icon>
                          </div>
                          </template>
                          <span>Traspaso entre cuentas</span>
                        </v-tooltip>

                        <v-tooltip top v-else-if="item.conciliation_state == 'done_externally' && !item.asiento">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="btn-table-transaction btn-pointer" 
                              color="primary"                              
                              v-bind="attrs" 
                              v-on="on"
                              @click="showInsertAsientoDialog(item)">
                              <AppIcon :src="icons.asiento" :size="24" :colorMap="{ '060647': 'primary_blue' }" />
                          </div>
                          </template>
                          <span>Introducir asiento</span>
                        </v-tooltip>

                        <v-tooltip top v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-if="item.conciliation_state == 'draft'"
                              class="mr-1 btn-table-transaction btn-pointer" 
                              color="primary"                              
                              v-bind="attrs" 
                              v-on="on"
                              @click="updateSingleCounterpart(item.id)">
                              <AppIcon :src="icons.assertRule" :colorMap="{ '060647': 'primary_blue' }" :size="24" v-if="!loading_update_counterpart_transactions[item.id]" />
                              <v-progress-circular v-else indeterminate></v-progress-circular>                              
                            </div>
                            <div v-else class="btn-table-transaction"><AppIcon :src="icons.assertRuleDisabled" :size="24" :preserveColors="true"/></div>
                          </template>
                          <span>Actualizar Contrapartida con reglas</span>
                        </v-tooltip>

                        <v-tooltip top v-if="currentCompany.companydb_type.value == 'innuva'">
                          <template v-slot:activator="{ on, attrs }">
                            <div 
                            v-bind="attrs" 
                            v-on="on"
                            class="mr-1 lg-square-icon-text primary-icon white--text"
                            >
                              A
                            </div>
                          </template>
                          <span>Actividad: {{ item.activity_code }}</span>
                        </v-tooltip>

                        <v-tooltip top v-if="currentCompany.companydb_type.value == 'innuva'">
                          <template v-slot:activator="{ on, attrs }">
                            <div 
                            v-bind="attrs" 
                            v-on="on"
                            class="lg-square-icon-text primary-icon white--text"
                            >
                              C
                            </div>
                          </template>
                          <span>Canal: {{ item.channel_code }}</span>
                        </v-tooltip>
                      </template>
                      
                      <JobProgress
                        v-if="(permission.can_write && got_feature('feature_download_transaction_pdf') 
                          && item && item.additional_information && item.additional_information.has_pdf)"
                        :value="getDownloadPDFJobState(item.id)"
                        @input="$set(downloadPDFJobStates, item.id, $event)"
                        v-on:done="downloadTransactionPDFJobDone(item.id)"
                        v-on:error="downloadTransactionPDFJobError(item.id)"
                        :job_id="getDownloadPDFJobId(item.id)"
                      >
                        <div slot="progress">
                          <v-btn
                            icon
                            v-if="getDownloadPDFJobState(item.id)==='running'"
                            color="primary"
                            :loading="true"
                          >
                            <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                        </div>
                        <div slot="done">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="downloadTransactionPDF(item.id)"
                              >
                                <v-icon small class="material-symbols-outlined">file_save</v-icon>
                              </v-btn>
                            </template>
                            <span>Descargar recibo</span>
                          </v-tooltip>
                        </div>
                        <div slot="error">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="downloadTransactionPDF(item.id)"
                              >
                                <v-icon small class="material-symbols-outlined">file_save</v-icon>
                              </v-btn>
                            </template>
                            <span>Descargar recibo</span>
                          </v-tooltip>
                        </div>
                      </JobProgress>
                    </div>

                  </template>                  

                  <template v-slot:expanded-item="{ headers, item }">
                    <td colspan="2" :class="[itemExpandedBackground(item), {'expanded-with-department': got_feature('feature_departments') && got_feature('feature_departments_bank')}]">&nbsp;</td>
                    <td
                      :colspan="(headers.length -4)" :class="[itemExpandedBackground(item), {'expanded-with-department': got_feature('feature_departments') && got_feature('feature_departments_bank')}]">
                      <div class="d-flex justify-space-between expandend-container">
                        <div class="exp-field">
                          <div class="exp-label">Fecha valor</div>
                          <div class="exp-value" v-if="item.additional_information.valueDate">{{ changeFormat(item.additional_information.valueDate) }}</div>
                          <div class="exp-value" v-else>-</div>                          
                        </div>
                        <div class="exp-field">
                          <div class="exp-label">Concepto original</div>
                          <div class="exp-value">{{ item.additional_information.original_concept }}</div>
                        </div>
                        <div class="exp-field" v-if="got_feature('feature_use_different_currencies_in_banks') && currentBankAccount && currentBankAccount.currency && !currentBankAccount.currency.includes('EUR')">
                          <div class="exp-label">Tipo de conversión</div>
                          <div class="exp-value" v-if="item.currency_value">{{ item.currency_value }}</div>
                          <div class="exp-value" v-else>-</div> 
                        </div>
                        <div class="exp-field" v-if="item.amount < 0">
                          <div class="exp-label">Acreedor</div>                          
                          <div class="exp-value" v-if="item.additional_information.creditor_name">{{ item.additional_information.creditor_name }}</div>
                          <div class="exp-value" v-else>-</div>                        
                        </div>
                        <div class="exp-field" v-else>
                          <div class="exp-label">Deudor</div>
                          <div class="exp-value" v-if="item.additional_information.debtor_name">{{ item.additional_information.debtor_name }}</div>
                          <div class="exp-value" v-else>-</div>                          
                        </div>
                        <div class="exp-field">
                          <div class="exp-label">Saldo</div>
                          <div class="exp-value">
                            <input style="min-width:30px;"
                              type="number"
                              v-model="item.balance_after_transaction"
                              @input="setDirty(item.id);"
                              @change="setDirtyAndSave(item)"
                              :readonly="item.conciliation_state != 'draft' || !permission.can_write"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mt-2 pb-4" v-if="got_feature('feature_departments') && got_feature('feature_departments_bank')">
                        <div class="exp-field">
                          <div class="exp-label">Departamento</div>
                          <div class="exp-value">
                            <v-select
                              :items="departments"
                              v-model="item.department_id"
                              item-text="name"
                              item-value="department_id"
                              clearable
                              dense
                              hide-details
                              @change="setDirtyAndSave(item)"
                              :readonly="item.conciliation_state != 'draft' || !permission.can_write"
                              style="min-width: 150px;"
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td colspan="2" :class="[itemExpandedBackground(item), {'expanded-with-department': got_feature('feature_departments') && got_feature('feature_departments_bank')}]">&nbsp;</td>
                  </template>
              
                  </v-data-table>
                  <div class="transactions-total-amount"><span>Importe: </span>{{ totalAmountSelectedTransactions }}</div>
                </v-container>
              </v-card-text>

              <app-confirm-modal
                v-model="showDeleteTransactionsPupup"
                :text-msg="msgDeleteTransactionsPupup"
                :loading="loading_d_tr"
                @confirm="deleteTransactions()"
                @cancel="showDeleteTransactionsPupup = false"
              >
              </app-confirm-modal>
              <app-confirm-modal
                v-model="showRevertDoneToDrafDialog"
                :text-msg="msgRevertDoneToDrafDialog"
                @confirm="updateStateDoneToDraft()"
                @cancel="showRevertDoneToDrafDialog = false"
              >
              </app-confirm-modal>

          <MessagePopup message="Ha ocurrido un error al borrar los elementos"
            :show_message="show_error_message" @close-message="show_error_message=false">
          </MessagePopup>

          <!-- Error messages: empty account / more than one analytic entity assigned -->
          <MessagePopup message="No se puede guardar el movimiento con la cuenta de la contrapartida vacía"
            :show_message="show_save_account_error_message" @close-message="show_save_account_error_message=false">
          </MessagePopup>
          <MessagePopup :message="'No se puede guardar el movimiento con más de un ' + analyticsColumnName + ' distinto asignado'"
            :show_message="show_save_analytic_entity_error_message" @close-message="show_save_analytic_entity_error_message=false">
          </MessagePopup>
          <!--------->

          <v-dialog v-if="currentBankAccount" v-model="dialog_upload_excel" max-width="816" height="550">
            <v-card class="rounded-lg upload">
              <v-card-title class="upload__header">
                <div class="upload__header-left">
                  <span class="upload__title">Subir Transacciones</span>
                </div>
                <app-btn outlined @click="cancelUploadFile()" class="upload__close">×</app-btn>
              </v-card-title>

              <div class="upload__body">
                <div class="upload__content">
                  <div class="upload__content-inner">

                    <v-subheader class="upload__content__subheader" v-if="fileType === 'excel'">
                      <span class="static-text">Cuenta:</span>
                      <span class="dinamic-text"> {{ currentBankAccount.iban }} </span> 
                    </v-subheader>

                    <div class="form__group">
                      <span class="form__label">Tipo</span>
                      <div class="form__box">
                        <v-select
                          :items="configBankItems"
                          v-model="fileType"
                          item-text="text"
                          item-value="id"
                          class="form__select"
                          :placeholder="configBankItems[0].text"
                        />
                      </div>
                    </div>
                    <template v-if="fileType === 'excel'">
                      <div class="form__group">
                        <div class="form__box">
                   
                          <v-file-input
                            v-model="file"
                            accept=".xls, .xlsx, .xlsm, .ods"
                            :clearable="false"
                            :loading="loading_upload_excel"
                            :error="error_upload_file"
                            :error-messages="error_message_upload_file"
                            :prepend-icon="null"
                            label=""
                            placeholder="Archivo"
                            dense
                            flat
                            hide-details="auto"
                            class="form__file"
                            @change="resetFileError"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon class="form__file-icon">mdi-paperclip</v-icon>
                            </template>
                          </v-file-input>

                        </div>
                      </div>

                      <div class="form__group form__group--gap">
                        <div v-if="isDefaultExcelConfig" style="width: 100%;">
                          <v-subheader class="form__label" style="height: 14px; padding: 0;">Orden de Cabecera</v-subheader>
                          <div class="form__box">
                            <span class="form__text">Concepto / Importe / Fecha / Saldo* / Tercero*</span>
                          </div>
                        </div>

                        <div class="form__config-row">
                          <v-btn
                            @click="dialog_upload_excel = false; showConfigurationPopUp = true"
                            text small elevation="0" :ripple="false" type="button" 
                            style="color:#454545;font-family:Roboto;font-size:13px;font-weight:500;text-transform:none;border-radius:10px;background:#F3F3F3;"
                          >
                            Configuración Cabecera
                          </v-btn>
                        </div>

                      </div>
                    </template>

                    <span v-if="fileType=='norma43'">
                      <v-row>
                        <v-col align="center" class="pb-0">
                          <v-icon color="primary" size="39">mdi-file-document-alert-outline</v-icon>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col align="center">
                          <span class="text-h6 primary--text">Importante</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col align="center">
                          <p>Sólo se cargarán los movimientos relacionados con la cuenta seleccionada</p>
                        </v-col>
                      </v-row>
                      <v-row v-if="fileType">
                        <v-col cols="12">
                          <v-file-input
                            class="rounded-lg"
                            label="Archivo"
                            v-model="file"
                            prepend-icon="mdi-paperclip"
                            color="primary"
                            accept=" .n43"
                            :clearable="false"
                            :loading="loading_upload_excel"
                            :error="error_upload_file"
                            :error-messages="error_message_upload_file"
                            outlined
                            @change="resetFileError"
                          />
                        </v-col>
                      </v-row>
                    </span>

                  </div>
                </div>
              </div>

              <v-card-actions class="upload__actions">
                <app-btn
                  color="primary"
                  @click="uploadExcelTrans()"
                  variant="text"
                  :loading="loading_upload_excel"
                >
                  Subir
                </app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_first_import_gocardless" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span class="text-h5 primary--text py-1 ml-2">Carga de movimiento</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <span>Importar movimientos de través del proveedor desde:</span>
                <date-picker
                  aucomplete="off"
                  v-model="transactions_date_from"
                ></date-picker>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <app-btn variant="text" outlined @click="dialog_first_import_gocardless=false">Cancelar</app-btn>
                <app-btn color="primary" variant="text" @click="uploadTransactions(true)" :disabled="!transactions_date_from" :loading="loadingUploadTransaction">Importar</app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="addTransactionPopup" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span class="text-h5 primary--text py-1 ml-2">Añadir movimiento</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12">
                    <app-text-field
                      label="Concepto"
                      type="text"
                      v-model="new_concept"
                    >
                    </app-text-field>
                  </app-col>
                </app-row>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12">
                    <app-text-field
                      label="Importe"
                      type="number"
                      v-model="new_amount"
                    >
                    </app-text-field>
                  </app-col>
                </app-row>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12">
                    <app-date-picker
                      aucomplete="off"
                      label="Fecha"
                      v-model="new_date"
                    ></app-date-picker>
                  </app-col>
                </app-row>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12">
                    <app-text-field
                      label="Saldo"
                      type="number"
                      v-model="new_balance_after_transaction"
                    >
                    </app-text-field>
                  </app-col>
                </app-row>
                <app-row>
                  <app-col cols="12">
                    <v-checkbox
                      v-model="initial_transaction"
                      label="Movimiento de apertura"/>
                  </app-col>
                </app-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <app-btn outlined @click="addTransactionPopup=false">Cancelar</app-btn>
                <app-btn 
                  color="primary" 
                  @click="addTransaction()" 
                  :loading="loading_add_transaction"
                  :disabled="(!new_concept || !new_amount || !new_date) || (initial_transaction && !new_balance_after_transaction)"
                >
                  Crear
                </app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-model="dialog_update_massive_counterpart" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span class="text-h5 primary--text py-1 ml-2">Actualizar contrapartida movimientos</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <app-row contains-input-fields class="mt-4">
                  <app-col contains-input-fields cols="12">
                    <AppContrapartidaField                
                      v-model="update_massive_counterpart_account"
                      :items="accounts"
                      @get-values="getValues"
                      @reset-items="resetItems"
                      :num_digits="currentCompany.num_digits"
                      :show_balance="false"
                      label="Contrapartida"
                      >
                    </AppContrapartidaField>
                  </app-col>
                </app-row>
                <app-row contains-input-fields class="mt-4">
                  <app-col contains-input-fields cols="12">
                    <app-text-field
                      label="* Concepto"
                      type="text"
                      v-model="update_massive_counterpart_concept"
                    >
                    </app-text-field>
                  </app-col>
                  <small class="ml-3">* Dejar el campo concepto vacio si no se quiere cambiar el original</small>                  
                </app-row>                
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <app-btn outlined @click="dialog_update_massive_counterpart=false">Cancelar</app-btn>
                <app-btn 
                  color="primary" 
                  @click="updateMassiveCounterpart()" 
                  :loading="loading_update_massive_counterpart"
                  :disabled="!update_massive_counterpart_account"
                >
                  Actualizar
                </app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_update_activity_channel" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span class="text-h5 primary--text py-1 ml-2">Configurar Actividad y Canal</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12" class="pt-0">
                    <div class="d-flex align-center default-acccount-effects-input" >
                      <div class="pl-4 pr-3 v-label">Actividad</div>
                      <v-select
                        :items="activities"
                        v-model="masive_update_activity"
                        item-text="name" 
                        item-value="id"
                      ></v-select>
                    </div>
                  </app-col>
                </app-row>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12" class="pt-0">
                    <div class="d-flex align-center default-acccount-effects-input" >
                      <div class="pl-4 pr-3 v-label">Canal</div>
                      <v-select
                        :items="channels"
                        v-model="masive_update_channel"
                        item-text="name" 
                        item-value="id"
                      ></v-select>
                    </div>
                  </app-col>
                </app-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <app-btn outlined @click="dialog_update_activity_channel=false">Cancelar</app-btn>
                <app-btn 
                  color="primary" 
                  @click="updateTransactionsActivityChannel()" 
                  :loading="loading_update_activity_channel"
                  :disabled="!masive_update_activity.length || !masive_update_channel.length"
                >
                  Guardar
                </app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_update_department" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span class="text-h5 primary--text py-1 ml-2">Configurar Departamento</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <app-row contains-input-fields>
                  <app-col contains-input-fields cols="12" class="pt-0">
                    <div class="d-flex align-center default-acccount-effects-input" >
                      <div class="pl-4 pr-3 v-label">Departamento</div>
                      <v-select
                        :items="departments"
                        v-model="masive_update_department"
                        item-text="name"
                        item-value="department_id"
                        clearable
                      ></v-select>
                    </div>
                  </app-col>
                </app-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <app-btn outlined @click="dialog_update_department=false">Cancelar</app-btn>
                <app-btn
                  color="primary"
                  @click="updateTransactionsDepartment()"
                  :loading="loading_update_department"
                >
                  Guardar
                </app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

    <dialog-bank-counterpart 
      v-if="dialog_transaction"
      :show_message="showDialogCounterPart"             
      :object_id="dialog_transaction.id"
      :object_amount="dialog_transaction.amount"
      :counterparts="dialog_transaction.contrapartida"
      :default_concept="dialog_transaction.concept"
      :readonly="dialog_transaction.conciliation_state != 'draft' || !permission.can_write ? true: false"
      :effects="dialog_transaction.amount >= 0 ? receivableEffects: payableEffects"
      :company_id="currentCompany.id"
      :num_digits="currentCompany.num_digits"
      :work_with_effects="workWithEffects"
      :company_analytic_entities="companyAnalyticEntities"
      :analytic_attr_name="analyticsAttrName"
      @close-dialog="closeCounterpartsDialog"
      @save-dialog="saveCounterpartsDialog" >
    </dialog-bank-counterpart>

    <v-dialog
      v-model="dialog_launch_upload_transactions_electron"
      persistent 
      max-width="600"
      >
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Cargar movimientos del programa contable</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <span>Importar movimientos hasta la fecha:</span>
          <v-form v-model="isValidFormUploadTransacionsElectron">
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="upload_transacions_electron_max_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="dialog_launch_upload_transactions_electron=false">Cancelar</v-btn>
          <v-btn 
            color="white" 
            :disabled="!isValidFormUploadTransacionsElectron" 
            text 
            class="primary-bckground" 
            @click="launchOperationUploadBankTransactions()" 
            >Importar</v-btn>
        </v-card-actions>
      </v-card>
    
    </v-dialog>

    <v-dialog
      v-model="dialog_import_effects"
      persistent 
      max-width="600"
      >
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Sincronizar efectos con facturas en Inmatic</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
        
          <v-form v-model="isValidFormImportEffects">
            <div>Fesde desde:</div>
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="import_effects_min_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
            <div>Fesde hasta:</div>
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="import_effects_max_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="dialog_import_effects=false">Cancelar</v-btn>
          <v-btn 
            :loading="loading_import_effects"
            color="white" 
            :disabled="!isValidFormImportEffects" 
            text 
            class="primary-bckground" 
            @click="importEffectsForTransactionsCounterparts()" 
            >Sincronizar</v-btn>
        </v-card-actions>
      </v-card>
    
    </v-dialog>


    <v-snackbar
        v-model="snackbar.isVisible"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
    >
        {{ snackbar.text }}
    </v-snackbar>

    <app-confirm-modal
      v-model="show_error_upload_transactions"
      :text-msg="'Se ha perdido la conexión con el banco.'"
      @confirm="redirect_to_conect_bank_again()"
      @cancel="show_error_upload_transactions = false"
      :textQuestion="'¿Desea reconectarlo?'"
    >
    </app-confirm-modal>

    <app-confirm-modal
      v-model="show_generic_error"
      :text-msg="generic_error_msg"
      @confirm="show_generic_error = false"
      :textConfirmButton="'Aceptar'"
      :showTextQuestion="false"
      :showCancelButton="false"
    >
    </app-confirm-modal>

    <app-confirm-modal
      v-model="show_generic_selected_transactions_error"
      :text-msg="'No puede realizar esta acción porque alguna de las transacciones seleccionadas ya está en proceso de contabilización.'"
      @confirm="show_generic_selected_transactions_error = false"
      :textConfirmButton="'Aceptar'"
      :showTextQuestion="false"
      :showCancelButton="false"
    >
    </app-confirm-modal>

    <app-confirm-modal
      v-model="show_pending_sync_warning"
      :text-msg="'Alguna de las transacciones que está marcando como contabilizada externamente está en estado pendiente de sincronización. Para aceptar el riesgo de marcar como contabilizada una transacción que en realidad no esté contabilizada en su sistema clique Aceptar.'"
      @confirm="confirmUpdateStateDoneExternally"
      @cancel="cancelUpdateStateDoneExternally"
      :textConfirmButton="'Aceptar'"
      :textCancelButton="'Cancelar'"
      :showTextQuestion="false"
      :showCancelButton="true"
    >
    </app-confirm-modal>

    <v-dialog v-model="show_dialog_transfer_between_accounts" max-width="660">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Movimientos bancarios entre cuentas</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="pt-5 pl-5 pr-5 font-weight-medium text-center text-body-1">
            <p>Parece ser que este movimiento pertenece a un traspaso entre cuentas. Primero debes contabilizar el movimiento negativo en su respectivo banco y después marcar este como contabilizado indicando el número de asiento.</p>
          </div>
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-text-field
                label="Asiento"
                type="text"
                v-model="asiento"
              >
              </app-text-field>
            </app-col>
          </app-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn outlined @click="show_dialog_transfer_between_accounts = false">Cancelar</app-btn>
          <app-btn 
            color="primary" 
            @click="setConciliationStateToDoneManual()" 
            variant="text"
            :disabled="!asiento"
            :loading='loading_show_dialog_transfer_between_accounts'
          >
            Contabilizar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="show_dialog_insert_asiento_manual_dialog" max-width="660">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Insertar asiento manualmente</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="pt-5 pl-5 pr-5 font-weight-medium text-center text-body-1">
            <p>Insertar asiento manualmente de un movimiento contabilizado externamente.</p>
          </div>
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-text-field
                label="Asiento"
                type="text"
                v-model="asiento"
              >
              </app-text-field>
            </app-col>
          </app-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn outlined @click="show_dialog_insert_asiento_manual_dialog = false">Cancelar</app-btn>
          <app-btn 
            color="primary" 
            @click="setAsientoManual()"
            variant="text"
            :disabled="!asiento"
            :loading='loading_show_dialog_insert_asiento_manual_dialog'
          >
            Actualizar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showConfigurationPopUp" max-width="900">
      <v-card>
        <v-card-title class="headline" style="display: flex; flex-direction: row; justify-content: space-around; align-items: center;">
          
          <span class="upload__title primary--text">
            Configuración
          </span>

          <div v-if="currentBankAccount && currentBankAccount.iban" class="bank-account-header">

            <v-subheader class="subheader-container">
              <span class="static-text">Banco:</span> 
              <span class="dinamic-text"> {{ currentBankAccount.institution }} </span>
            </v-subheader>

            <v-subheader class="subheader-container" style="padding: 0;">
              <span class="static-text">Cuenta:</span>
              <span class="dinamic-text"> {{ currentBankAccount.iban }} </span> 
            </v-subheader>

          </div>

          <app-btn outlined @click="closePopUpConfiguration()" class="close__modal" style="border: none!important;">
            ×
          </app-btn>
        </v-card-title>

        <v-divider/>

        <div
          style="
            display: flex;
            width: 550px;
            height: 30px;
            justify-content: flex-start;
            flex-shrink: 0;
            flex-direction: row;
            padding: 5px;
          "
        >
          <v-btn
            @click="openUploadExcelPopUp()"
            style="
              background: transparent;
              box-shadow: none;
              min-width: 0;
              padding: 0;
              text-transform: none;
            "
          >
            <span
              style="
                color: #888;
                font-family: Roboto;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                padding: 30px;
              "
            >
              ← Ir a subir excel
            </span>
          </v-btn>
        </div>

        <v-card-text class="pt-5">

          <!-- Menú tabs visuales -->
          <div class="d-flex pl-4 pt-2">
            <span
              @click="activeTab = 'config'"
              :style="tabToShow === 'config' ? activeTabStyle : inactiveTabStyle"
            >
              Configuración de Movimiento
            </span>
            <span
              class="ml-5"
              @click="activeTab = 'excel'"
              :style="tabToShow === 'excel' ? activeTabStyle : inactiveTabStyle"
            >
              Selector de Columnas Excel
            </span>
          </div>

          <section style="margin-top: 24px; display: flex; flex-direction: column; align-items: flex-start;">
            <!-- CONTENIDO DEL TAB: Configuración de Movimiento -->
            <div v-if="tabToShow === 'config'">
              <app-row contains-input-fields>
                <app-col contains-input-fields cols="12">
                  <v-checkbox
                    class="ma-0 pt-5 pl-4"
                    v-model="concatenateConcept"
                    :disabled="loadingShowConfigurationPopUp"
                  >
                    <template v-slot:label>
                      <span class="text-field-size">Concatenar concepto con Deudor | Acreedor</span>
                    </template>
                  </v-checkbox>
                </app-col>
              </app-row>

              <app-row contains-input-fields>
                <app-col contains-input-fields cols="12">
                  <v-checkbox
                    class="ma-0 pt-5 pl-4"
                    v-model="avoidDetectTransferBetweenAccounts"
                    :disabled="loadingShowConfigurationPopUp"
                  >
                    <template v-slot:label>
                      <span class="text-field-size">Deshabilitar detección de traspaso entre cuentas para esta cuenta</span>
                    </template>
                  </v-checkbox>
                </app-col>
              </app-row>

              <app-row contains-input-fields>
                <app-col contains-input-fields cols="12">
                  <v-checkbox
                    class="ma-0 pt-5 pl-4"
                    v-model="automatic_apply_rules"
                    label="Aplicar reglas automáticamente"
                  ></v-checkbox>
                </app-col>
              </app-row>
            </div>

            <!-- CONTENIDO DEL TAB: Selector de Columnas Excel -->
            <div v-if="tabToShow === 'excel'" class="pl-4 pr-4">
              <BankColumnsConfiguratorTab
                :excel_format="excel_format"
                @update:excel_format="excel_format = $event"
                @confirm="saveFormat"
                :currentBankAccount="currentBankAccount"
              />
            </div>
          </section>

          <div v-if="tabToShow !== 'excel'">
            <app-row contains-input-fields v-if="got_feature('feature_can_use_payable_or_receivable_effects')">
              <app-col contains-input-fields cols="12">
                <v-checkbox
                  class="ma-0 pt-5 pl-4"
                  v-model="workWithEffects"
                  :disabled="loadingShowConfigurationPopUp"
                >
                  <template v-slot:label>
                    <span class="text-field-size">Trabajar con partidas abiertas</span>
                  </template>
                </v-checkbox>
              </app-col>
            </app-row>

            <app-row contains-input-fields v-if="got_feature('feature_can_use_payable_or_receivable_effects') && workWithEffects">
              <app-col contains-input-fields cols="12" class="pt-0">
                <div class="d-flex align-center default-acccount-effects-input" >
                  <div class="pl-4 pr-3 v-label">Cuenta de ingresos descuadre efectos</div>
                  <ContrapartidaField                
                    v-model="default_effects_cuenta_ingresos"
                    :items="accounts"
                    @get-values="getValues"
                    @reset-items="resetItems"
                    :num_digits="currentCompany.num_digits"
                    :show_balance="false"
                    >
                  </ContrapartidaField>
                </div>
              </app-col>
            </app-row>

            <app-row contains-input-fields v-if="got_feature('feature_can_use_payable_or_receivable_effects') && workWithEffects">
              <app-col contains-input-fields cols="12">
                <div class="d-flex align-center default-acccount-effects-input" >
                  <div class="pl-4 pr-3 v-label">Cuenta de gastos descuadre efectos</div>
                  <ContrapartidaField                
                    v-model="default_effects_cuenta_gastos"
                    :items="accounts"
                    @get-values="getValues"
                    @reset-items="resetItems"
                    :num_digits="currentCompany.num_digits"
                    :show_balance="false"
                    >
                  </ContrapartidaField>
                </div>
              </app-col>
            </app-row>
        
            <app-row contains-input-fields v-if="['gocardless', 'afterbanks'].includes(currentBankAccount.kind)">
              <app-col contains-input-fields cols="12">
                  <v-checkbox
                  class="ma-0 pt-5 pl-4"
                  v-model="automatic_upload_transactions"
                >
                <template v-slot:label>
                  <span class="text-field-size">
                    Descarga automática diaria de movimientos
                    <i>(6:00h-7:00h peninsular aprox.)</i>
                  </span>
                </template>
              </v-checkbox>
              </app-col>
            </app-row>

          </div>

          <app-row contains-input-fields v-if="currentCompany.companydb_type.value == 'innuva'">
            <app-col contains-input-fields cols="12" class="pt-0">
              <div class="d-flex align-center default-acccount-effects-input" >
                <div class="pl-4 pr-3 v-label">Actividad</div>
                <v-select
                  :items="activities"
                  v-model="activity_code"
                  item-text="name" 
                  item-value="id"
                ></v-select>
              </div>
            </app-col>
          </app-row>

          <app-row contains-input-fields v-if="currentCompany.companydb_type.value == 'innuva'">
            <app-col contains-input-fields cols="12" class="pt-0">
              <div class="d-flex align-center default-acccount-effects-input" >
                <div class="pl-4 pr-3 v-label">Canal</div>
                <v-select
                  :items="channels"
                  v-model="channel_code"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </div>
            </app-col>
          </app-row>

          <app-row contains-input-fields v-if="got_feature('feature_departments') && got_feature('feature_departments_bank')">
            <app-col contains-input-fields cols="12" class="pt-0">
              <div class="d-flex align-center default-acccount-effects-input" >
                <div class="pl-4 pr-3 v-label">Departamento por defecto</div>
                <v-select
                  :items="departments"
                  v-model="department_id"
                  item-text="name"
                  item-value="department_id"
                  clearable
                ></v-select>
              </div>
            </app-col>
          </app-row>

        </v-card-text>
        
        <v-card-actions class="upload__actions">
          <app-btn 
            @click="updateConfiguration()" 
            :loading='loadingShowConfigurationPopUp'
          >
            Guardar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialog_puntear_effects" persistent max-width="540">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Selecciona comportamiento para descuadre</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-8">          
          <v-radio-group v-model="puntear_effect_mode">
            <v-radio label="Descuadre a cuenta por defecto" value="default_account"></v-radio>
            <v-radio label="Crear nuevo efecto con descuadre" value="create_effect"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn variant="text" outlined @click="dialog_puntear_effects=false">Cancelar</app-btn>
          <app-btn color="primary" variant="text" @click="puntearTransactionEffects(puntear_effect_mode)" :loading="puntearLoading">Puntear efecto</app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-confirm-modal
      v-model="reconnectPopup"
      :text-msg="'Se ha perdido la conexión con el banco.'"
      @confirm="BankReconnectAccept()"
      @cancel="reconnectPopup = false"
      :textQuestion="'¿Desea reconectarlo?'"
      :loading="reconnectPopupLoading"
    >
    </app-confirm-modal>

    <app-confirm-modal
      v-model="showGenericInformationDialog"
      :text-msg="genericInformationDialogMsg"
      @confirm="showGenericInformationDialog = false"
      :textConfirmButton="'Aceptar'"
      :showTextQuestion="false"
      :showCancelButton="false"
      :titleIcon="'mdi-information-outline'"
    >
    </app-confirm-modal>

    <v-dialog v-model="showOTPCodeDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Confirmación con doble factor</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="pt-5 pl-3 font-weight-medium text-body-1">
            <span v-if="otp_message != ''">{{otp_message}}</span>
            <span v-else>Por favor, introduzca el código recibido</span>
          </div>
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-text-field
                label="Código"
                type="text"
                v-model="OTPCode"
              >
              </app-text-field>
            </app-col>
          </app-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn outlined @click="showOTPCodeDialog = false">Cancelar</app-btn>
          <app-btn 
            color="primary" 
            @click="sendCode()" 
            variant="text"
            :disabled="!OTPCode"
            :loading='loadingShowOTPCodeDialog'
          >
            Enviar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="transferTransactionsPopup" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Traspaso de transacciones</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <app-select
            class="transfer-bank-select"
            :items="availableBanks"
            item-value="id"
            v-model="selectedBank"
            :hide-details="true"
            label="Banco"
          >
            <template v-slot:selection="{ item }">
              {{ displayBankOption(item) }}
            </template>
            <template v-slot:item="{ item }">
              {{ displayBankOption(item) }}
            </template>
          </app-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn outlined @click="transferTransactionsPopup=false">Cancelar</app-btn>
          <app-btn class="btn-accept" color="primary" variant="text" @click="transferTransactions()" :disabled="!selectedBank">Confirmar</app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showConciliationErrorDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="red" class="mr-2">mdi-alert</v-icon>
          Error de contabilización
        </v-card-title>
        <v-card-text>
          {{ conciliationErrorText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn outlined @click="showConciliationErrorDialog = false">Cerrar</app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import { UploadFileTransactions } from "@/modules/bank/application/UploadFileTransactions";
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher, query_dispatcher_2} from "@/api/client";
import { CreateLoadBankTransactions } from "@/modules/bank/application/CreateLoadBankTransactions";
import { BankAccountTransactions } from "@/modules/bank/application/BankAccountTransactions";
import { saveTransactionCommand } from "@/modules/bank/application/saveTransactionCommand";
import { generateRuleFromTransactionCommand } from "@/modules/bank/application/generateRuleFromTransaction";
import { DeleteTransactions } from "@/modules/bank/application/DeleteTransactions";
import { UploadBankAccountTransactions } from "@/modules/bank/application/UploadBankAccountTransactions";
import { BankAccountQuery } from "@/modules/bank/application/BankAccountQuery";
import { SetTransactionCounterpart } from "@/modules/bank/application/SetTransactionCounterpart";
import { SetTransactionCounterpartManual } from "@/modules/bank/application/SetTransactionCounterpartManual";
import { SetTransactionActivityChannel } from "@/modules/bank/application/SetTransactionActivityChannel";
import { SetTransactionDepartment } from "@/modules/bank/application/SetTransactionDepartment";
import { MarkAsReviewed } from "@/modules/bank/application/MarkAsReviewed";
import { CreateTransactionManual } from "@/modules/bank/application/CreateTransactionManual";
import { LaunchOperationUploadBankTransactions } from "@/modules/bank/application/LaunchOperationUploadBankTransactions";
import { DownloadCsvTransactions } from "@/modules/bank/application/DownloadCsvTransactions";
import { BankAccountList } from "@/modules/bank/application/BankAccountList";
import { ActivitiesQuery } from "@/modules/bank/application/ActivitiesQuery";
import { ChannelsQuery } from "@/modules/bank/application/ChannelsQuery";
import { GetAnalyticEntitiesQuery } from "@/modules/bank/application/GetAnalyticEntitiesQuery";
import { GetAvailableBanksQuery } from "@/modules/bank/application/GetAvailableBanks";
import { TransferTransactionsCommand } from "@/modules/bank/application/TransferTransactions";
import { UpdateBankConfigurationCommand } from "@/modules/bank/application/UpdateBankConfiguration";
import { GetEffectCounterpartListQuery } from "@/modules/bank/application/GetEffectCounterpartList";
import { ImportEffectsCommand } from "@/modules/bank/application/ImportEffectsCommand";
import { ReconnectLinkCommand } from "@/modules/bank/application/ReconnectLink";
import { PuntearTransactionEffectsCommand } from "@/modules/bank/application/PuntearTransactionEffectsCommand";
import { DespuntearTransactionEffectsCommand } from "@/modules/bank/application/DespuntearTransactionEffectsCommand";
// import { ReconcileTransactionsFromEffectsCommand } from "@/modules/bank/application/ReconcileTransactionsFromEffectsCommand";
import { SetTransactionStateErrorToDraftCommand } from "@/modules/bank/application/SetTransactionStateErrorToDraftCommand";
import { SetTransactionStateDoneExternallyCommand } from "@/modules/bank/application/SetTransactionStateDoneExternallyCommand";
import { SetTransactionStateDoneToDraftCommand } from "@/modules/bank/application/SetTransactionStateDoneToDraftCommand";
import { RecalculateBalanceCommand } from "@/modules/bank/application/RecalculateBalance";
import { DownloadTransactionPDFCommand } from "@/modules/bank/application/DownloadTransactionPDFCommand";
import MessagePopup from '@/components/MessagePopup.vue';
import DialogBankCounterpart from "./DialogBankCounterpart.vue";
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppDatePicker from '@/components/layout/AppDatePicker.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import { mapActions } from "vuex";
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import { mapState, mapGetters } from "vuex"; 
import awsconfig from '../aws-exports';
import DatePicker from '@/components/DatePicker.vue'
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import { jobs } from '../api/jobs.js';
import JobProgress from '../components/JobProgress.vue';
import BankSimpleFilters from "@/components/BankSimpleFilters.vue"
import ContrapartidaField from "./layout/ContrapartidaField.vue";
import AppContrapartidaField from "./layout/AppContrapartidaField.vue";
import AppSelect from '@/components/layout/AppSelect.vue';
import BankColumnsConfiguratorTab from "./BankColumnsConfiguratorTab.vue";

export default {

  name: 'BankAccountDetail',
  components: {
    MessagePopup,
    AppConfirmModal,
    AppSearchBar,
    DatePicker,
    AppRow,
    AppCol,
    AppBtn,
    AppTextField,
    AppSelect,
    AppDatePicker,
    DialogBankCounterpart,
    JobProgress,
    BankSimpleFilters,
    ContrapartidaField,
    AppContrapartidaField,
    BankColumnsConfiguratorTab
  },
  props: {
    bank_account_id: {
        type: String,
        required: true
    },
    selectedTransactionsP: {
        type: Array,
        required: true
    },
    selectedEffects: {
      type: Array,
      required: true,
    },
    classes: {
      type:String,
      default:''
    }
  },
  data() {
    return {
      // Pre-cargar iconos para evitar múltiples requires en cada render
      icons: {
        backArrow: require('../assets/bank-back-arrow.svg'),
        uploadFile: require('../assets/bank-upload-file.svg'),
        importBank: require('../assets/import-bank.svg'),
        filters: require('../assets/bank-filters.svg'),
        downloadAuto: require('../assets/download_transactions_auto.svg'),
        syncEffects: require('../assets/bank-sync-effects.svg'),
        config: require('../assets/bank-config.svg'),
        toggleRules: require('../assets/toggle-rules.svg'),
        toggleRules2: require('../assets/toggle-rules2.svg'),
        transferActive: require('../assets/transfer_transactions_active.svg'),
        transfer: require('../assets/transfer_transactions.svg'),
        generateRules: require('../assets/bank-generate-rules.svg'),
        generateRulesDisabled: require('../assets/bank-generate-rules-disabled.svg'),
        btnPlus: require('../assets/btn-plus.svg'),
        btnEye: require('../assets/btn-eye.svg'),
        btnPencil: require('../assets/btn-pencil.svg'),
        saveDisabled: require('../assets/bank-save-transaction-disabled.svg'),
        save: require('../assets/bank-save-transaction.svg'),
        generateRule: require('../assets/bank-generate-rule.svg'),
        asiento: require('../assets/bank-asiento.svg'),
        assertRule: require('../assets/bank-assert-rule.svg'),
        assertRuleDisabled: require('../assets/bank-assert-rule-disabled.svg'),
      },
      snackbar: {
        isVisible: false,
        text: '',
        color: '',
        timeout: 3000,
      },
      file: null,
      loading_upload_excel: false,
      dialog_upload_excel: false,
      uploadFileTransactionsJobState: 'done',
      uploadFileTransactionsJobId: 0,      
      show_error_message:false,
      loading_d_tr: false,
      msgDeleteTransactionsPupup:'Se van a borrar los movimientos selecionados.',
      msgRevertDoneToDrafDialog: 'Es necesario eliminar el asiento de tu programa contable de forma manual. Esta acción no elimina el registro.',
      showSelectTransactions: false, 
      showDeleteTransactionsPupup: false,
      showRevertDoneToDrafDialog: false,
      showConciliationErrorDialog: false,
      conciliationErrorText: '',
      deleteTransactionsJobState: 'done',
      deleteTransactionsJobId: 0,
      contabilizarLoading: false,
      loading_list:false,
      totalTransactions: 0,
      totalAmountTransactions:0,
      hasProviderTransactions:false,
      selectedTransactions:[],
      transactions_list:[],
      transactions_headers: [
        // {
        //   text: 'Nombre',
        //   sortable: false,
        //   value:'name'
        // },
        {
          text: 'A',
          sortable: false,
          value: 'default_contrapartida',
          width:1,
        },
        {
          text: 'Punteado',
          sortable: false,
          value: 'punteado',
          width:1,
        },
        {
          text: 'Fecha registro',
          sortable: false,
          value: 'bookingDate'
        },       
        {
          text: 'Concepto',
          sortable: false,
          value: 'concept',
          width:275,
        },
        {
          text: 'Importe',
          sortable: false,
          value: 'amount'
        },
        {
          text: 'Saldo calculado',
          sortable: false,
          value: 'calculated_balance'
        },      
        {
          text: 'Contrapartida',
          sortable: false,
          value: 'contrapartida',
        },
        {
          text: 'Analitica',
          sortable: false,
          value: 'analytics',
        },
        {
          text: 'Asiento',
          sortable: false,
          value: 'asiento'
        },
        {
          text: 'Estado',
          sortable: false,
          value: 'conciliation_state'
        },        
        {
          text: '',
          align: 'end',
          sortable: false,
          value: 'actions',
        },
        { text: '', sortable: false, value: 'data-table-expand' },     
      ],
      conciliation_state_choices: {
        draft: "Borrador",
        pending: "Contabilizando",
        accounting: "Contabilizando...",
        done: "Contabilizado",
        done_externally: "Contabilizado externamente",
        pending_sync: "Pendiente de sincronización",
        imported: "Importado",
        error: "Error",
        downloaded: "Descargado",
      },
      loading_transactions: {},
      loading_generate_rule_transactions: {},
      loading_update_counterpart_transactions: {},
      show_counterpart_fields: {},
      loadingUploadTransaction:false,
      loading_launch_operation_upload: false,
      loading_import_effects: false,
      dialog_import_effects: false,
      import_effects_min_date: undefined,
      import_effects_max_date: undefined,
      loading_reconcile_trasactions_effects: false,
      isValidFormImportEffects: false,
      loading_update_state_done_draft: false,
      loading_update_state_error_draft:false,
      loading_update_state_done_externally:false,
      dialog_launch_upload_transactions_electron:false,
      upload_transacions_electron_max_date: undefined,
      isValidFormUploadTransacionsElectron:false,
      currentBankAccount: {},
      mark_as_reviewed: false,
      uncheck_reviewed: false,
      dialog_first_import_gocardless: false,
      transactions_date_from: undefined,
      addTransactionPopup: false,
      new_concept: undefined,
      new_amount: undefined,
      new_date:undefined,
      new_balance_after_transaction:undefined,
      initial_transaction:false,
      loading_add_transaction: false,
      showFilters: true, 
      showDialogCounterPart: false,
      dialog_counterparts: '',
      dialog_transaction: null,
      dirty: [],
      row_expanded: [],
      url_to_active_again: undefined,
      show_error_upload_transactions: false,
      show_generic_error:false,
      generic_error_msg: '',
      fileType: '',
      show_generic_selected_transactions_error:false,
      show_pending_sync_warning:false,
      asyncJobState: 'done',
      asyncJobId: 0,
      action: '',
      error_upload_file: false,
      error_message_upload_file: '',
      tableHeight: '59vh',
      limit:10,
      offset:0,
      pageTransactions:1,
      show_mismatch: false,
      bank_accounts: [],
      bank_account_list: [],
      show_dialog_transfer_between_accounts: false,
      loading_show_dialog_transfer_between_accounts: false,
      asiento:undefined,
      updateTransaction:undefined,
      show_dialog_insert_asiento_manual_dialog: false,
      loading_show_dialog_insert_asiento_manual_dialog: false,
      showConfigurationPopUp: false,
      loadingShowConfigurationPopUp: false,
      concatenateConcept:false,
      avoidDetectTransferBetweenAccounts:false,
      workWithEffects: false,
      default_effects_cuenta_ingresos: '',
      default_effects_cuenta_gastos: '',
      activity_code: '',
      channel_code: '',
      department_id: '',
      dialog_update_department: false,
      loading_update_department: false,
      masive_update_department: '',
      uploadProviderJobState: 'done',
      uploadProviderJobId: 0,
      importEffectsJobState: 'done',
      importEffectsJobId: 0,
      receivableEffects:[],
      payableEffects:[],
      totalEffects:[],
      totalEffectsCopy:[],
      filteredEffectsCounterpart:[],
      activeTab: '',
      reconnectPopup: false,
      reconnectPopupLoading: false,
      showGenericInformationDialog: false,
      genericInformationDialogMsg: '',
      showRules:true,
      show_save_account_error_message: false,
      show_save_analytic_entity_error_message: false,
      puntearLoading: false,
      despuntearLoading: false,
      dialog_puntear_effects: false,
      puntear_effect_mode: 'default_account',
      accounts:[],
      activities: [],
      channels: [],
      reconcile_with_excel: false,
      showOTPCodeDialog: false,
      OTPCode: '',
      loadingShowOTPCodeDialog: false,
      initial_transactions_filters: [{
            'name': 'state',
            'label': 'Estado',
            'values':[], // TODO: multiple?
            'user_values': [
                { value: '', text: 'Todos'},
                { value: 'draft', text: 'Borrador'},
                { value: 'pending', text: 'Contabilizando'},
                { value: 'accounting', text: 'Contabilizando...'},
                { value: 'done', text: 'Contabilizado'},
                { value: 'not_done', text: 'No Contabilizado'},
                { value: 'done_imported', text: 'Contabilizado y importado'},
                { value: 'not_done_imported', text: 'No Contabilizado ni importado'},
                { value: 'pending_sync', text: 'Pte. de sincronización'},
                { value: 'imported', text: 'Importado'},
                { value: 'error', text: 'Error'},
                { value: 'downloaded', text: 'Descargado'},
            ],
            'multiple': false,
            'value': 'not_done',
            'type': 'select',
            'icon': 'mdi-file-chart',
            'text':'No Contabilizado',
            'initial': true
        },],
        automatic_upload_transactions: false,
        automatic_apply_rules: false,
        dialog_update_massive_counterpart: false,
        loading_update_massive_counterpart: false,
        update_massive_counterpart_account: '',
        update_massive_counterpart_concept: '',
        dialog_update_activity_channel: false,
        loading_update_activity_channel: false,
        masive_update_activity: '',
        masive_update_channel: '',
        otp_message: '',
        excel_format: {},
        availableBanks: [],
        transferTransactionsPopup: false,
        selectedBank: null,
        activeTabStyle: {
          fontWeight: '600',
          color: 'var(--v-primary-base)',
          borderBottom: '2px solid var(--v-primary-base)',
          paddingBottom: '8px',
        },
        inactiveTabStyle: {
          fontWeight: '400',
          color: '#888',
          borderBottom: '2px solid transparent',
          paddingBottom: '8px',
        },
        file: null,
        error_upload_file: false,
        error_message_upload_file: '',
        loading_upload_excel: false,
        isDefaultExcelConfig: true,
        fileType: null,
        configBankItems: [
          { id: 'excel', text: 'Excel' },
          { id: 'norma43', text: 'Norma43' }
        ],
        companyAnalyticEntities: [],
        recalculateBalanceLoading: false,
        downloadPDFJobStates: {},
        downloadPDFJobIds: {},
      };
  },
  computed: {
    ...mapGetters({
      got_feature:'got_feature',
      permission: 'permissions/permission',
      userData: 'me/userData',
    }),
    ...mapState(['session_information']),
    ...mapState(['currentCompany']),
    ...mapState(['departments']),
    ...mapGetters('transactions', ['listFilters']),
    transactions_headers_no_expand: function () {
      let headers = this.transactions_headers.filter((item) => (item.value !== 'data-table-expand'))
      let analitica_index = this.transactions_headers.findIndex(obj => obj.value == 'analytics')
      if (this.got_feature('feature_project_bank_counterpart')) {
        headers[analitica_index].text = this.analyticsColumnName
      }
      else {
        headers.splice(analitica_index, 1) // remove 'analitica' header if feature not active
      }
      return headers
    },
    totalAmountSelectedTransactions(){
      let total = 0
      if (this.selectedTransactions.length > 0) {
        for (let t in this.selectedTransactions) {
          total+=this.selectedTransactions[t].amount;
        }
      }
      else {
        total = this.totalAmountTransactions
      }
      return total
    },
    show_possible_duplicates(){
      if (this.listFilters && this.listFilters['possible_duplicates']) {
        let show_pd = this.listFilters['possible_duplicates'].value === 'yes' ? true : false;
        this.show_mismatch = show_pd ? false : this.show_mismatch;
        return show_pd;
      }
      return false;
    },
    tabToShow() {
      return this.activeTab || 'config'
    },
    canPuntear() {
      // 1xN or Nx1 only, and no forbidden states
      const t = this.selectedTransactions.length;
      const e = this.selectedEffects.length;
      if (t === 1 && e >= 1) {
        const tx = this.selectedTransactions[0];
        return !['done', 'imported', 'downloaded'].includes(tx.conciliation_state);
      }
      if (t >= 1 && e === 1) {
        // Allow Nx1 regardless of states of others? Keep same tx-state rule: all must be draft-like
        return this.selectedTransactions.every(tx => !['done', 'imported', 'downloaded'].includes(tx.conciliation_state));
      }
      return false;
    },
    canDespuntear() {
      // Only transactions, at least 1, effects must be 0
      return this.selectedTransactions.length >= 1 && this.selectedEffects.length === 0;
    },
    analyticsAttrName() {
      switch (this.currentCompany.companydb_type.value) {
        case 'a3':
          return 'department'
        case 'contasol':
          return 'project'
        default:
          return null
      }
    },
    analyticsColumnName() {
      switch (this.currentCompany.companydb_type.value) {
        case 'a3':
          return 'Departamento'
        case 'contasol':
          return 'Proyecto'
        default:
          return null
      }
    },
  },
  methods: {
    getDownloadPDFJobState(transactionId) {
      return this.downloadPDFJobStates[transactionId] || 'done';
    },
    getDownloadPDFJobId(transactionId) {
      return this.downloadPDFJobIds[transactionId] || 0;
    },
    openPopUpConfiguration() {
      this.showConfigurationPopUp = true
    },
    closePopUpConfiguration() {
      this.showConfigurationPopUp = false; 
      this.refreshBankAccount()
    },
    async refreshBankAccount() {
        try { 
          await new BankAccountQuery(query_dispatcher, this).run(this.$route.params.bank_account_id);
          this.concatenateConcept = this.currentBankAccount.concatenate_concept;
          this.avoidDetectTransferBetweenAccounts = this.currentBankAccount.avoid_detect_transfer_between_accounts;
          this.workWithEffects = this.currentBankAccount.work_with_effects;
          this.default_effects_cuenta_gastos = this.currentBankAccount.default_effects_cuenta_gastos;
          this.default_effects_cuenta_ingresos = this.currentBankAccount.default_effects_cuenta_ingresos;
          this.automatic_upload_transactions = this.currentBankAccount.automatic_upload_transactions;
          this.automatic_apply_rules = this.currentBankAccount.automatic_apply_rules;
          this.activity_code = this.currentBankAccount.activity_code;
          this.channel_code = this.currentBankAccount.channel_code;
          this.department_id = this.currentBankAccount.department_id;
          if (this.workWithEffects) {
              this.transactions_headers.unshift(
                {
                  text: 'P',
                  sortable: false,
                  value: 'contains_effects',
                  width:1,
                }
            )
          }
          this.excel_format = this.currentBankAccount.excel_format
          
          this.isDefaultExcelConfig = this.excel_format.is_default

      } catch (error) {
          console.error('Error getting bank account', error);                
      }
    },
    resetFileError() {
      this.error_upload_file = false
      this.error_message_upload_file = ''
    },
    displayBankOption(item) {
      if (!item) return '';
      const name = item.name || item.ownerName || 'Banco';
      const iban = item.iban || '';
      return iban ? `${name} (${iban})` : name;
    },
    ...mapActions("cru", ['getAccounts2']),
    ...mapActions("transactions", ['updateObject','removeAllFilters']),
    async updateFilter(params){
      this.updateObject(params)
      this.offset = 0;      
      let simpleFilters = this.$refs.bankSimpleFilters.option_selected;
      
      await new BankAccountTransactions(query_dispatcher_2, this).run_filter(this.$route.params.bank_account_id, this.listFilters, simpleFilters, this.limit, this.offset)
      this.pageTransactions = 1
    },
    async removeAllFilt(p){
      this.removeAllFilters()
      await new BankAccountTransactions(query_dispatcher_2, this).run_filter(this.$route.params.bank_account_id, this.listFilters, this.$refs.bankSimpleFilters.option_selected, this.limit, this.offset)
    },
    async refreshListTransactions() {
      await new BankAccountTransactions(query_dispatcher_2, this).run_filter(this.$route.params.bank_account_id, this.listFilters, this.$refs.bankSimpleFilters.option_selected, this.limit, this.offset)
    },
    async refreshEffectsList() {
      try {
        await new GetEffectCounterpartListQuery(query_dispatcher, this).run(this.currentBankAccount.id)
      } catch (error) { 
        console.error(error);
      }
    },
    itemRowBackground(item) {
      if (this.show_possible_duplicates && item.duplicate_group !== undefined) {
        return  (item.duplicate_group % 2 === 0) ? 'color-group-even' : 'color-group-odd';
      }

      if (
        this.show_mismatch &&
        item.balance_after_transaction != null &&
        Math.round(item.balance_after_transaction * 100) / 100 !== Math.round(item.calculated_balance * 100) / 100
      ) {
        return 'background_warning';
      }

      return null;
    },

    itemExpandedBackground(item) {
      if (this.show_possible_duplicates && item.duplicate_group !== undefined) {
        return (item.duplicate_group % 2 === 0) ? 'color-group-even__expanded' : 'color-group-odd__expanded';
      }

      if (
        this.show_mismatch &&
        item.balance_after_transaction != null &&
        Math.round(item.balance_after_transaction * 100) / 100 !== Math.round(item.calculated_balance * 100) / 100
      ) {
        return 'background_warning__expended';
      }

      return null;
    },
    calculateTableHeight() {
      this.initNumItemsPerPage = Math.min(this.limit, 10);
      if (this.totalTransactions == 0) {
        this.tableHeight = '20vh';
      }
      else {
        const rowHeight = document.querySelector('.text-start') && document.querySelector('.text-start').offsetHeight || 48;
        this.tableHeight = rowHeight * (Math.min(this.totalTransactions, this.initNumItemsPerPage) + 1);
        // Añadir altura extra si feature departamentos está activa (para fila expandida)
        const extraHeight = this.got_feature('feature_departments') && this.got_feature('feature_departments_bank') ? 50 : 0;
        if (this.totalTransactions < 10 || this.limit <10) {
          this.tableHeight = (this.tableHeight + 100 + extraHeight).toString() + 'px'
        } else {
          this.tableHeight = (this.tableHeight + extraHeight).toString() + 'px'
        }
      }
    },
    async changeOffset(value) {
      this.offset = this.limit*(value-1);
      this.pageTransactions = value
      await this.refreshListTransactions()
    },
    async changeLimit(value) {
      this.limit = value;
      this.calculateTableHeight();
      await this.refreshListTransactions()
    },
    async launchOperationUploadBankTransactions() {
      this.dialog_launch_upload_transactions_electron = false;
      this.loading_launch_operation_upload = true;      
      try {
        await new LaunchOperationUploadBankTransactions(sync_command_dispatcher, this).run(this.currentBankAccount.id, this.upload_transacions_electron_max_date)
      } catch (e) {
        console.log(e);
      }
      this.loading_launch_operation_upload = false;
    },
    async toggleShowFilters(){
      this.showFilters = !this.showFilters;
      await this.removeAllFilt()
    },    
    openUploadExcelPopUp(){
      this.showConfigurationPopUp = false
      this.dialog_upload_excel = true
    },
    openCounterpartsDialog(transaction) {
      this.dialog_transaction = transaction;
      this.showDialogCounterPart = true;
    },
    closeCounterpartsDialog() {
      this.showDialogCounterPart = false;
    },
    saveCounterpartsDialog(data) {
      let original_item = null;
      let item = null;
      let item_idx = null;
      for (let i in this.transactions_list) {
        if (this.transactions_list[i].id == data.object_id) {
          original_item = structuredClone(this.transactions_list[i].contrapartida)
          item_idx = i
          this.transactions_list[i].contrapartida = data.counterparts;
          item = this.transactions_list[i];
          break;
        }
      }
      this.setDirty(data.object_id);
      this.showDialogCounterPart = false;
      if (item !=null) {
        this.saveTransaction(item);
      }
      if (this.show_save_account_error_message || this.show_save_analytic_entity_error_message) {
        // No se ha guardado, revertir cambios
        this.transactions_list[item_idx].contrapartida = original_item
      }
    },
    setDirty(transaction_id) {
      if (this.dirty.indexOf(transaction_id) === -1) {
        this.dirty.push(transaction_id)
      }            
    },
    unsetDirty(transaction_id) {
      if (this.dirty.indexOf(transaction_id) !== -1) {
        this.dirty.splice(this.dirty.indexOf(transaction_id), 1);
      }
    },
    isDirty(transaction_id) {
      if (this.dirty.includes(transaction_id)) {
        return true;
      }
      else {
        return false;  
      }      
    },
    changeTransactionConcept(transaction) {
      if (transaction.contrapartida.length == 1) {        
        transaction.contrapartida[0].concept = transaction.concept;        
      }
      this.setDirty(transaction.id);      
    },
    setDirtyAndSave(transaction) {
      this.setDirty(transaction.id);
      this.saveTransaction(transaction)      
    },    
    async getValues(params) {
      params['companydb_id'] = this.currentCompany.id
      let items = await this.getAccounts2(params);
      this.accounts = items;
      // this.getAccounts2(params).then((items) => {
      //   this.accounts = items;
      // });
    },
    resetItems(params) {
      this.accounts = params;
    },
    getEffectsCounterpartValues(amount, text) {
      this.filteredEffectsCounterpart = this.filteredEffectsByAmountAndText(amount, text)      
    },
    myNativeInputEffectCounterpart(event,item) {      
      this.getEffectsCounterpartValues(item.amount, event.target.value)
    },
    resetEffectsCounterpartItems(params){
      
    },
    changeFormat(dateString){
      const dateObject = new Date(dateString);
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    },
    displayConciliationState(transaction) {
      const conciliation_state = transaction.conciliation_state

      if (conciliation_state in this.conciliation_state_choices) {
        return this.conciliation_state_choices[conciliation_state]
      }
      else {
        return conciliation_state
      }
    },
    copyIdToClipboard(id) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        navigator.clipboard.writeText(id)
          .then(() => console.log("ID copiado:", id))
          .catch(err => console.error("Error al copiar ID:", err));
      } else {
        // Fallback para navegadores antiguos
        const textArea = document.createElement("textarea");
        textArea.value = id;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
        } catch (err) {
          console.error("Fallback copy failed:", err);
        }
        document.body.removeChild(textArea);
      }
    },
    showErrorDialog(item) {
      let errorText = undefined
      if (item.error) {
        errorText = Object.values(item.error).join(' - ')
      }
      else {
        errorText = 'Se ha producido un error en la contabilización'
      }

      this.conciliationErrorText = errorText;
      this.showConciliationErrorDialog = true;
    },
    change_loading_get_transactions(uuid, value){
      this.loading_list = value
    },
    checkDefaultCounterpart(contrapartidas) {
      let ac_partidas_abiertas = this.currentBankAccount.cuenta_partidas_abiertas      
      if (contrapartidas.length > 1) {
        return false;
      }
      else if (typeof(contrapartidas[0].account) === 'object'){
        if (contrapartidas[0].account.kind == 'effect' || contrapartidas[0].account.account != ac_partidas_abiertas) {
          return false;
        }
        else {
          return true;
        }
      }
      else if (contrapartidas[0].kind == 'effect' || contrapartidas[0].account != ac_partidas_abiertas) {
        return false;
      }
      else {
        return true;
      }
    },
    checkContainsEffects(contrapartidas) {
      for (let i in contrapartidas) {
        if (contrapartidas[i].kind == 'effect') {
          return true;
        }
      }
      return false;
    },
    checkEmptyCounterpartAccount(contrapartidas) {
      for (let i in contrapartidas) {
        if (!contrapartidas[i].account) {
          return true;
        }
      }
      return false;
    },
    onlyOneAnalyticEntity(contrapartidas) {
      const attr_name = this.analyticsAttrName
      let analytic_id = null
      let i = 0

      for (i; i < contrapartidas.length; i++) {
        if (contrapartidas[i][attr_name] != null) {
          analytic_id = contrapartidas[i][attr_name] // analytic entity id
          break // 1st not null analytic entity found
        }
      }
      i++
      for (i; i < contrapartidas.length; i++) { // compare the remaining elements with the one found
        if (contrapartidas[i][attr_name] != null && analytic_id !== contrapartidas[i][attr_name]) return false
      }
      return true
    },
    getAnalyticsCode(contrapartidas) {
      // find 1st non-null analytics value of attribute named 'attr_name'
      const attr_name = this.analyticsAttrName
      
      let analytic_id = undefined
      for (const contra of contrapartidas) {
        if (contra.hasOwnProperty(attr_name) && contra[attr_name]) {
          analytic_id = contra[attr_name]
          break
        }
      }
      if (analytic_id != null) {
        const analytic_entity = this.companyAnalyticEntities.find( obj => obj.id == analytic_id )
        if (analytic_entity != null) return analytic_entity.external_id
      }
      return ''
    },
    async saveTransaction(item){
      if (this.isDirty(item.id) && !this.loading_transactions[item.id]){
        if (this.checkEmptyCounterpartAccount(item.contrapartida)) {
          this.show_save_account_error_message = true
        }
        else if (!this.onlyOneAnalyticEntity(item.contrapartida)) {
          this.show_save_analytic_entity_error_message = true
        }
        else {
          item.default_contrapartida=this.checkDefaultCounterpart(item.contrapartida);
          item.contains_effects = this.checkContainsEffects(item.contrapartida);
          try {
            await new saveTransactionCommand(sync_command_dispatcher, this).run(item, this.currentBankAccount.id)
          } catch (error) {
            console.error('Error while update bank account', error)
          }
          this.unsetDirty(item.id);
        }
      }
    },
    change_loading_save_transaction(id, value){
      let cp = Object.assign({}, this.loading_transactions);
      cp[id]=value
      this.loading_transactions=cp;
    },
    change_loading_generate_rule_transaction(id, value){
      let cp = Object.assign({}, this.loading_generate_rule_transactions);
      cp[id]=value
      this.loading_generate_rule_transactions=cp;
    },
    change_loading_update_counterpart_transaction(id, value){
      let cp = Object.assign({}, this.loading_update_counterpart_transactions);
      cp[id]=value
      this.loading_update_counterpart_transactions=cp;
    },
    change_show_counterpart_field(id, value){
      let cp = Object.assign({}, this.show_counterpart_fields);
      cp[id]=value
      this.show_counterpart_fields=cp;
    },
    showCounterpartField(item) {
      if (item.conciliation_state == 'draft' && this.permission.can_write) {
        this.change_show_counterpart_field(item.id, true)
      }
    },
    switchCounterpartKind(item) {
      if (item.conciliation_state == 'draft' && this.permission.can_write) {
        item.contrapartida[0].kind=='account'? item.contrapartida[0].kind='effect': item.contrapartida[0].kind='account'; 
        item.contrapartida[0].account = '';
        this.showCounterpartField(item);
      }
    },
    async generateRule(item){
      if (!this.loading_generate_rule_transactions[item.id]) {      
        this.change_loading_generate_rule_transaction(item.id, true)
        try {
          await new generateRuleFromTransactionCommand(sync_command_dispatcher, this).run([item.id])
        } catch (error) {
          console.error('Error while generate rule from transaction', error)
        }
        this.change_loading_generate_rule_transaction(item.id, false)
      }
    },
    async generateRuleFromTransactions() {
      let t_ids = this.getSelectedTransactions();
      try {
        await new generateRuleFromTransactionCommand(async_command_dispatcher, this).run_async_job(t_ids)
      } catch (error) {
        console.error('Error while generate rule from transactions', error)
      }
    },
    async importEffectsForTransactionsCounterparts() {      
      this.loading_import_effects = true;
      try {
        await new ImportEffectsCommand(async_command_dispatcher, this).run(this.currentCompany.id, this.import_effects_min_date, this.import_effects_max_date)
      } catch (e) {
        console.log(e);
      }
      this.dialog_import_effects = false;
      this.snackbar.isVisible = true
      this.snackbar.text = 'Sincronizando efectos Inmatic'
      this.snackbar.color = 'success'
      this.loading_import_effects = false;
    },
    filteredEffectsByAmount(amount) {      
      if (amount >= 0) {
        return this.receivableEffects.filter((x) => Math.abs(x.amount) <= Math.abs(amount));
      }
      else {
        return this.payableEffects.filter((x) => Math.abs(x.amount) <= Math.abs(amount));
      }
    },
    filteredEffectsByAmountAndText(amount, text) {
      if (text) {
        if (amount >= 0) {
          return this.receivableEffects.filter((x) => Math.abs(x.amount) <= Math.abs(amount) && x.concept.toLowerCase().includes(text.toLowerCase()));
        }
        else {
          return this.payableEffects.filter((x) => Math.abs(x.amount) <= Math.abs(amount) && x.concept.toLowerCase().includes(text.toLowerCase()));
        }
      } else {
        if (amount >= 0) {
          return this.receivableEffects.filter((x) => Math.abs(x.amount) <= Math.abs(amount));
        }
        else {
          return this.payableEffects.filter((x) => Math.abs(x.amount) <= Math.abs(amount));
        }
      }
    },
    changeEffect(item) {
      if (typeof(item.contrapartida[0].account) === 'object')  {
        if (item.contrapartida[0].account.effect_type == 'receivable_effect') {
          item.contrapartida[0].account.amount = -item.contrapartida[0].account.amount
        }
        item.contrapartida[0] = item.contrapartida[0].account;
      }
      this.setDirty(item.id);
      this.saveTransaction(item);
    },
    getSelectedTransactions(){
      let selected_ids = []
      for(let i in this.selectedTransactions){
        selected_ids.push(this.selectedTransactions[i].id)
      }
      return selected_ids
    },
    checkIfThereAnyAccountingTransactions(){
      for(let i in this.selectedTransactions) {
        if(this.selectedTransactions[i].conciliation_state != 'draft') {
          return true;
        }
      }
      return false;
    },
    checkIfSelectedTransactionsStateNotInStates(states) {
      for(let i in this.selectedTransactions) {
        if(!states.includes(this.selectedTransactions[i].conciliation_state)) {
          return true;
        }
      }
      return false;
    },
    checkIfTransactionsHaveNoCounterpartAccount() {
      for(let i in this.selectedTransactions) {   
        if (this.selectedTransactions[i].contrapartida.length == 0) {
          return true
        }     
        for(let x in this.selectedTransactions[i].contrapartida) {
          if (!this.selectedTransactions[i].contrapartida[x].account ) {
            return true;
          }
        }
      }
      return false;
    },
    canAccountTransactions() {
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
        return false;
      }
      let no_account = this.checkIfTransactionsHaveNoCounterpartAccount()
      if (no_account) {
        this.generic_error_msg = 'No se pueden contabilizar los movimientos ya que en alguno no se ha informado de la contrapartida'
        this.show_generic_error = true
        return false;
      }
      if(this.currentCompany.companydb_type.value=='innuva') {
        if (!this.activity_code || !this.channel_code || !this.activity_code.length || !this.channel_code.length) {
          this.generic_error_msg = 'Es necesario configurar la Actividad y el Canal'
          this.show_generic_error = true
          return false;
        }
      }
      return true;
    },
    loading_delete_transactions(value) {
      this.loading_d_tr = value
    },
    async deleteTransactions() {
      let del_t = this.getSelectedTransactions()
      try {
        await new DeleteTransactions(async_command_dispatcher, this).run(del_t, this.currentBankAccount.id, this.listFilters)
      } catch(error) {
        console.error('Error delete transactions:', error);
      }
      this.showDeleteTransactionsPupup = false
    },
    async deleteTransactionsJobDone() {
      let response = await jobs.getJob({ id: this.deleteTransactionsJobId });
      this.deleteTransactionsJobState = response.data.state;
      const status = response.data.output_info['status'];
      if (status == 'error') {
        this.generic_error_msg = 'No se han podido eliminar las transacciones.'
        this.show_generic_error = true
      } else {
        this.genericInformationDialogMsg = "Transacciones eliminadas con éxito."
        this.showGenericInformationDialog = true
        await this.refreshListTransactions()
      }
    },
    loading_contabilizar_movimientos(value){
      this.contabilizarLoading = value
    },
    async contabilizar() {
      let t_ids = this.getSelectedTransactions()
      let can_account = this.canAccountTransactions()
      if (can_account) {      
        try {
          await new CreateLoadBankTransactions(sync_command_dispatcher,query_dispatcher_2,this).run(t_ids, this.currentBankAccount.id, this.listFilters)
        } catch(error) {
          console.error('Error contabilizar transactions:', error);
        }        
      }
    },
    async uploadExcelTrans(){

      if (!this.file) {
        this.error_upload_file = true
        this.error_message_upload_file = 'Archivo requerido'
        return
      }

      this.error_upload_file = false
      this.error_message_upload_file = ''
      this.creds = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
      });
      this.creds.params.Logins = this.creds.params.Logins || {};
      this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
      this.creds.expired = true;
      AWS.config.update({
          region: awsconfig['aws_user_files_s3_bucket_region'],
          credentials: this.creds,
      });

      try {
        this.changeLoadingUploadFileTransactions(true)
        let cmd =  new UploadFileTransactions(async_command_dispatcher, new S3Repository(AWS,'excel_t'), new S3Repository(AWS,'n43_t'), this)       
        await  cmd.run(this.currentBankAccount, this.file, this.fileType, this.listFilters, this.reconcile_with_excel, this.excel_format)
      } catch (error) {
        this.changeLoadingUploadFileTransactions(false)
        this.error_message_upload_file = 'No se han podido cargar las transacciones.'
        this.error_upload_file = true
        console.error('Error upload excel transactions', error)
      }
    },
    cancelUploadFile() {
      this.dialog_upload_excel = false;
      this.file = null;
      this.error_upload_file = false;
      this.error_message_upload_file = '';
      this.fileType=''
    },
    openOPTDialog() {
      this.showOTPCodeDialog = true;
    },
    async uploadProviderJobDone() {
      let response = await jobs.getJob({ id: this.uploadProviderJobId });
      this.uploadProviderJobState = response.data.state;
      const status = response.data.output_info['status'];
      if (status === 'error') {
        if (response.data && response.data.output_info && response.data.output_info['type'] === 'New authorization needed') {
          this.openBankReconnectPopUp()
        } else if (response.data && response.data.output_info && response.data.output_info['type'] === 'New code needed') {
          this.otp_message = response.data.output_info['info']
          this.openOPTDialog()
        } else if (response.data && response.data.output_info && response.data.output_info['type'] === 'Rate limit exceeded') {
          this.generic_error_msg = 'Se ha excedido el límite de peticiones diarias al banco. Por favor, inténtelo de nuevo mañana.'
          this.show_generic_error = true
        } else {
          this.generic_error_msg = 'Se ha producido un error al intentar obtener las transacciones. Por favor, inténtelo de nuevo más tarde.'
          this.show_generic_error = true
        }
      } else {
        this.genericInformationDialogMsg = "Transacciones cargadas con éxito."
        this.showGenericInformationDialog = true
        await this.refreshListTransactions()
      }
    },
    async uploadFileTransactionsJobDone() {
      let response = await jobs.getJob({ id: this.uploadFileTransactionsJobId });
      this.uploadFileTransactionsJobState = response.data.state;
      const status = response.data.output_info['status'];
      this.file = null

      this.changeLoadingUploadFileTransactions(false)
      if (status === 'error') {
        const errorMessages = {
          'Invalid format': this.fileType == 'norma43'
        ? 'El IBAN que aparece en el fichero no corresponde con este banco.'
        : 'El formato del fichero que se está intentando subir no es válido.',
          'The file is empty': 'El fichero está vacío.',
          'Invalid line length': 'Error en el formato de las líneas.',
          'Invalid amount format': 'Error en el formato de los importes.',
          'Invalid concept format': 'Error en el formato del concepto. No puede estar vacio.',
        };
        const errorMsg = response.data.output_info['error_message'];
        this.generic_error_msg = errorMessages[errorMsg] || 'No se han podido cargar las transacciones.';
        this.show_generic_error = true
      } else if (response.data.state === 'error') {
          this.generic_error_msg = 'Ha habido algun error con el formato del fichero'
          this.show_generic_error = true
      } else {
        if (response.data.output_info.async_job_set_transactions) {
          this.asyncJobState = 'running';
          this.asyncJobId = response.data.output_info.async_job_set_transactions;
          this.genericInformationDialogMsg = "Transacciones cargadas con éxito. Se están asignando las contrapartidas."
          this.action = 'update_counterparts'
        } else {
          this.genericInformationDialogMsg = "Transacciones cargadas con éxito."
        }
        this.showGenericInformationDialog = true
        await this.refreshListTransactions()
      }
      this.fileType = ''
    },
    uploadFileTransactionsJobError() {
      this.generic_error_msg = 'Ha habido un error inesperado al intentar cargar las transacciones. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, contacte con soporte.'
      this.show_generic_error = true
    },
    // async importEffectsJobDone() {
    //   let response = await jobs.getJob({ id: this.importEffectsJobId });
    //   this.importEffectsJobState = response.data.state;
    //   await this.refreshEffectsList()
    // },
    async showUploadDialogOrDirectUpload(){
      if (this.currentBankAccount.disconnected) {
        this.reconnectPopup = true;
      } else {
        if (this.hasProviderTransactions) {
          await this.uploadTransactions(false)
        } else {
          this.dialog_first_import_gocardless = true
        }
      }
    },
    changeLoadingUploadTransactions(value) {
      this.loadingUploadTransaction = value
    },
    changeLoadingUploadFileTransactions(value) {
      this.loading_upload_excel = value
    },
    async sendCode() {
      this.loadingShowOTPCodeDialog = true
      if (this.hasProviderTransactions) {
        await this.uploadTransactions(false)
      } else {
        await this.uploadTransactions(true)
      }
    },
    async uploadTransactions(value){
      let cmd = new UploadBankAccountTransactions(async_command_dispatcher, this)
      try {
        if (value){
          await cmd.run(this.currentBankAccount.id, value, this.transactions_date_from, this.listFilters, this.OTPCode)
        } else {
          await cmd.run(this.currentBankAccount.id, value, undefined, this.listFilters, this.OTPCode)
        }
      } catch (error) {
        console.error('Error upload transactions', error)
      }
    },   
    async updateCounterpart(){
      let t_ids = this.getSelectedTransactions()
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        try {
          await new SetTransactionCounterpart(async_command_dispatcher,query_dispatcher_2,this).run_async_job(t_ids)
        } catch(error) {
          console.error('Error update transactions counterpart:', error);
        }
      }
    },    
    async updateSingleCounterpart(item_id){
      if (!this.loading_update_counterpart_transactions[item_id]) {
        this.change_loading_update_counterpart_transaction(item_id, true)
        try {
          await new SetTransactionCounterpart(sync_command_dispatcher,query_dispatcher_2,this).run([item_id], this.currentBankAccount.id, this.listFilters)
        } catch(error) {
          console.error('Error update transactions counterpart:', error);
        }
        this.change_loading_update_counterpart_transaction(item_id, false)
      }
    },

    openUpdateMassiveCounterpartPopUp(){
      let t_ids = this.getSelectedTransactions()
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        this.dialog_update_massive_counterpart = true
      }
    },

    openUpdateActivityChannel(){
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        this.dialog_update_activity_channel = true
      }
    },

    openUpdateDepartment(){
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        this.dialog_update_department = true
      }
    },

    resetUpdateCounterpartDialog() {
      this.loading_update_massive_counterpart = false
      this.dialog_update_massive_counterpart = false
      this.update_massive_counterpart_account = ""
      this.update_massive_counterpart_concept = ""
    },

    async updateMassiveCounterpart() {
      this.loading_update_massive_counterpart = true
      let t_ids = this.getSelectedTransactions()
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        try {
          await new SetTransactionCounterpartManual(sync_command_dispatcher,query_dispatcher_2,this).run(t_ids, this.currentBankAccount.id, this.update_massive_counterpart_account, this.update_massive_counterpart_concept, this.listFilters)
        } catch(error) {
          console.error('Error update transactions counterpart manual:', error);
        }
      }
      this.resetUpdateCounterpartDialog()
    },    

    async updateStateDoneToDraft() {
      this.showRevertDoneToDrafDialog = false
      if (this.checkIfSelectedTransactionsStateNotInStates(['done', 'done_externally'])) {
        this.generic_error_msg = "Solo se pueden revertir a 'Borrador' los movimientos en estado 'Contabilizado' o 'Contabilizado externamente'"
        this.show_generic_error = true
      }
      else {
        let t_ids = this.getSelectedTransactions()
        try {
          let cmd = new SetTransactionStateDoneToDraftCommand(sync_command_dispatcher, query_dispatcher_2, this)
          await cmd.run(t_ids, this.currentBankAccount.id, this.listFilters)
        } catch(error) {
          console.error('Error update transactions state:', error)
        }
      }
    },
    async updateStateErrorToDraft(){
      this.loading_update_state_error_draft = true
      let t_ids = this.getSelectedTransactions()
      try {
          await new SetTransactionStateErrorToDraftCommand(sync_command_dispatcher,query_dispatcher_2,this).run(t_ids, this.currentBankAccount.id, this.listFilters)
      } catch(error) {
        console.error('Error update transactions state:', error);
      }
      this.loading_update_state_error_draft = false
    },
    async updateStateDoneExternally(){
      this.loading_update_state_done_externally = true
      if (this.checkIfSelectedTransactionsStateNotInStates(['draft', 'downloaded', 'pending_sync'])) {
        this.generic_error_msg = 'Solo se pueden poner como contabilizas externamente aquellos movimientos que esten en estado Borrador, Descargado o Pendiente de sincronización'
        this.show_generic_error = true
        this.loading_update_state_done_externally = false
      }
      else if (this.checkIfAnySelectedTransactionInState('pending_sync')) {
        this.show_pending_sync_warning = true
      }
      else {
        await this.executeUpdateStateDoneExternally()
      }
    },
    async executeUpdateStateDoneExternally(){
      let t_ids = this.getSelectedTransactions()
      try {
          await new SetTransactionStateDoneExternallyCommand(sync_command_dispatcher,query_dispatcher_2,this).run(t_ids, this.currentBankAccount.id, this.listFilters)
      } catch(error) {
        console.error('Error update transactions state:', error);
      }
      this.loading_update_state_done_externally = false
    },
    async confirmUpdateStateDoneExternally(){
      this.show_pending_sync_warning = false
      await this.executeUpdateStateDoneExternally()
    },
    cancelUpdateStateDoneExternally(){
      this.show_pending_sync_warning = false
      this.loading_update_state_done_externally = false
    },
    checkIfAnySelectedTransactionInState(state) {
      for(let i in this.selectedTransactions) {
        if(this.selectedTransactions[i].conciliation_state === state) {
          return true;
        }
      }
      return false;
    },
    async updateTransactionsActivityChannel() {
      this.loading_update_activity_channel = true
      let t_ids = this.getSelectedTransactions()
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        try {
          await new SetTransactionActivityChannel(sync_command_dispatcher, query_dispatcher_2,this).run(t_ids, this.currentBankAccount.id, this.masive_update_activity, this.masive_update_channel, this.listFilters)
        } catch(error) {
          console.error('Error update transactions activity and channel:', error);
        }
      }
      this.loading_update_activity_channel = false
      this.dialog_update_activity_channel = false
      this.masive_update_activity = ""
      this.masive_update_channel = ""
    },

    async updateTransactionsDepartment() {
      this.loading_update_department = true
      let t_ids = this.getSelectedTransactions()
      let state_not_ok = this.checkIfThereAnyAccountingTransactions()
      if (state_not_ok) {
        this.show_generic_selected_transactions_error = true
      } else {
        try {
          await new SetTransactionDepartment(sync_command_dispatcher, query_dispatcher_2, this).run(t_ids, this.currentBankAccount.id, this.masive_update_department, this.listFilters)
        } catch(error) {
          console.error('Error update transactions department:', error);
        }
      }
      this.loading_update_department = false
      this.dialog_update_department = false
      this.masive_update_department = ""
    },

    loading_uncheck_reviewed_transactions(value) {
      this.uncheck_reviewed = value
    },
    loading_mark_as_reviewed_transactions(value) {
      this.mark_as_reviewed = value
    },
    async markAsTransactionReviewed(value) {
      let t_ids = this.getSelectedTransactions()
      try {
        await new MarkAsReviewed(sync_command_dispatcher,query_dispatcher_2,this).run(t_ids, value, this.currentBankAccount.id, this.listFilters)
      } catch(error) {
        console.error('Error puntear/despuntear transactions:', error);
      }
    },
    change_loading_add_transaction(value){
      this.loading_add_transaction = value
    },
    async addTransaction() {
      try {
        await new CreateTransactionManual(sync_command_dispatcher,query_dispatcher_2,this).run(this.currentBankAccount.id, this.new_concept, this.new_date, this.new_amount, this.new_balance_after_transaction, this.initial_transaction, this.listFilters)
      } catch(error) {
        console.error('Error create transaction manual:', error);
      }
      this.addTransactionPopup = false
    },
    cleanImputs() {
      this.new_concept = undefined
      this.new_date = undefined
      this.new_amount = undefined
      this.new_balance_after_transaction = undefined
      this.initial_transaction = false
    },
    redirect_to_conect_bank_again() {
      if (this.currentBankAccount.kind == 'afterbanks') {
        this.$router.push({name: 'bank-creation', params: { company_id: this.currentCompany.id, bank_account_id: this.currentBankAccount.id, service_id: this.currentBankAccount.provider_information.service}});
      } else {
        window.location.href = this.url_to_active_again
      }
    },
    checkIfTraspasoEntreCuentasInSelectedTransactions(){
      for(let i in this.selectedTransactions){
        if (this.selectedTransactions[i].conciliation_state == 'draft' && this.selectedTransactions[i].amount < 0 && this.selectedTransactions[i].contrapartida.map((c)=>c.account).some(ac => this.bank_account_list.includes(ac))) {
          return true
        }        
      }
      return false
    },
    async download_csv(){
      if (this.checkIfTraspasoEntreCuentasInSelectedTransactions()) {
        this.generic_error_msg = 'No se puede descargar los movimientos ya que alguno de ellos es un traspaso entre sus cuentas bancarias. Primero debes contabilizar el movimiento positivo en su respectivo banco y después marcar este como contabilizado indicando el número de asiento.'
        this.show_generic_error = true
      }
      else {      
        let t_ids = this.getSelectedTransactions()            
        try {
          await new DownloadCsvTransactions(async_command_dispatcher,this).run(t_ids)
        } catch(error) {
          console.error('Error update transactions counterpart:', error);
        }
      }
    },
    async jobDone(){
      if (this.action == 'update_counterparts'){
        const response = await jobs.getJob({ id: this.asyncJobId });
        this.asyncJobState = response.data.state;
        this.genericInformationDialogMsg = "Se han actualizado las contrapartidas con éxito."
        this.showGenericInformationDialog = true
        await this.refreshListTransactions()
      } else if (this.action == 'generate_rules') {
        const response = await jobs.getJob({ id: this.asyncJobId });
        this.asyncJobState = response.data.state;
        this.genericInformationDialogMsg = "Reglas generadas con éxito."
        this.showGenericInformationDialog = true
        this.$root.$emit('getCompanyBankRules')
      } else if (this.action == 'download_csv') {
        const response = await jobs.getJob({ id: this.asyncJobId });
        this.asyncJobState = response.data.state;
        const status = response.data.output_info['status'];
        if (status == 'error') {
          let error_msg =  response.data.output_info['error_message']
          if (error_msg == 'error al intentar descargar excel') {
            this.generic_error_msg = 'Se ha producido un error al intentar descargar las transacciones. Por favor, inténtelo de nuevo más tarde.'
          } else if (error_msg == 'Columnas mal configuradas') {
            this.generic_error_msg = 'Configuración de columnas erronea. Por favor dirijase a ajustes para configurarlas correctamente.'
          } else {
            this.generic_error_msg = 'Saldo insuficiente. Por favor contrate alguno de los paquetes disponibles para poder realizar esta acción.'
          }
          this.show_generic_error = true
        } else if (status == 'ok') {
          let recived_url = response.data.output_info['url'];
          const res = await fetch(recived_url)
          const blob = await res.blob();
          const url = await URL.createObjectURL(blob)

          const a = document.createElement("a");
          a.href = url;
          a.download = 'transacciones.csv'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        if (this.got_feature('feature_bank_csv')) {
          await this.refreshListTransactions()
        }
      } else if (this.action == 'transfer_transactions') {
        const response = await jobs.getJob({ id: this.asyncJobId });
        this.asyncJobState = response.data.state;
        this.genericInformationDialogMsg = "Transferencias entre cuentas realizadas con éxito."
        this.showGenericInformationDialog = true
        await this.refreshListTransactions()
      } else {
        await this.refreshListTransactions()
      }
    },
    showInformationDialog(transaction) {
      this.updateTransaction = transaction;
      this.show_dialog_transfer_between_accounts = true;
    },    
    async setConciliationStateToDoneManual() {
      try {
        this.loading_show_dialog_transfer_between_accounts = true
        await new saveTransactionCommand(sync_command_dispatcher, this).run(this.updateTransaction, this.currentBankAccount.id, 'done', this.asiento)
      } catch (error) {
        console.error('Error while update bank account', error)
      }
      this.loading_show_dialog_transfer_between_accounts = false;
      this.show_dialog_transfer_between_accounts = false;
      this.asiento = undefined;
      await this.refreshListTransactions()
    },
    showInsertAsientoDialog(transaction) {
      this.updateTransaction = transaction
      this.show_dialog_insert_asiento_manual_dialog = true;
    },
    async setAsientoManual() {
      try {
        this.loading_show_dialog_insert_asiento_manual_dialog = true
        await new saveTransactionCommand(sync_command_dispatcher, this).run(this.updateTransaction, this.currentBankAccount.id, 'done_externally', this.asiento)
      } catch (error) {
        console.error('Error while update bank account', error)
      }
      this.loading_show_dialog_insert_asiento_manual_dialog = false;
      this.show_dialog_insert_asiento_manual_dialog = false;
      this.asiento = undefined;
      await this.refreshListTransactions()
    },
    async updateConfiguration(){
      try {
        await new UpdateBankConfigurationCommand(
          sync_command_dispatcher,
          query_dispatcher,
          this
        ).run(
          this.currentBankAccount.id,
          this.currentCompany.id,
          this.concatenateConcept,
          this.avoidDetectTransferBetweenAccounts,
          this.workWithEffects,
          this.default_effects_cuenta_ingresos,
          this.default_effects_cuenta_gastos,
          this.automatic_upload_transactions,
          this.automatic_apply_rules,
          this.activity_code,
          this.channel_code,
          this.department_id,
          this.excel_format
        )
        
        this.$emit('updateWorkWithEffects', this.workWithEffects)

      } catch (error) {
        console.error('Error while update bank account configuration', error)
      }
    },
    openBankReconnectPopUp(){
      this.reconnectPopup = true;
    },
    async BankReconnectAccept() {
      try {
        await new ReconnectLinkCommand(sync_command_dispatcher, this).run(this.currentBankAccount.id, this.currentCompany.id, this.currentBankAccount.institution, this.currentBankAccount.kind, this.currentBankAccount.provider_information.service)
      } catch (error) {
        console.error('Error while get redirect url', error)
      }
    },
    toggleShowRules(){
      this.showRules = !this.showRules;
      this.$emit('toggleShowRules', this.showRules);
    },
    emitUpdateTr() {
      this.$emit('updateT', this.selectedTransactions)
    },

  async checkAmountPuntearTransactionEffects() {
      const t = this.selectedTransactions.length;
      const e = this.selectedEffects.length;
      // 1 transacción x N efectos: como hasta ahora
      if (t === 1 && e >= 1 && !['done', 'imported', 'downloaded'].includes(this.selectedTransactions[0].conciliation_state)) {
        let descuadre = this.selectedTransactions[0].amount
        for (let i in this.selectedEffects) {
          if (this.selectedEffects[i].effect_type == 'payable_effect') {
            descuadre += this.selectedEffects[i].amount;
          } else {
            descuadre -= this.selectedEffects[i].amount;
          }
        }
        descuadre = Math.round(descuadre * 100) / 100;
        if (descuadre != 0) {
          this.dialog_puntear_effects = true;
          console.log("Descuadre distinto de 0:" + descuadre)
        }
        else {
          this.puntearTransactionEffects();
        }
      }
      // N transacciones x 1 efecto: solo si cuadran exactamente
      else if (t >= 2 && e === 1 && this.selectedTransactions.every(tx => !['done', 'imported', 'downloaded'].includes(tx.conciliation_state))) {
        const effect = this.selectedEffects[0];
        const sumTx = Math.round(this.selectedTransactions.reduce((acc, tx) => acc + tx.amount, 0) * 100) / 100;
        const desc = effect.effect_type === 'payable_effect'
          ? Math.round((sumTx + effect.amount) * 100) / 100
          : Math.round((sumTx - effect.amount) * 100) / 100;
        if (desc === 0) {
          await this.puntearTransactionEffects(); // no dialog, no mode
        } else {
          this.snackbar.isVisible = true
          this.snackbar.text = 'Los importes no cuadran. No se puede puntear.'
          this.snackbar.color = 'error'
        }
      }
    },
    async puntearTransactionEffects(mode = null) {
      this.dialog_puntear_effects = false;
      const t = this.selectedTransactions.length;
      const e = this.selectedEffects.length;
      try {
        if (t === 1 && e >= 1) {
          await new PuntearTransactionEffectsCommand(sync_command_dispatcher, this).run([this.selectedTransactions[0].id], this.selectedEffects.map((x) => x.id), mode)
        } else if (t >= 2 && e === 1) {

          await new PuntearTransactionEffectsCommand(sync_command_dispatcher, this).run(this.selectedTransactions.map(t => t.id), [this.selectedEffects[0].id])
        }
      } catch (error) {
        console.error('Error while PuntearTransactionEffectsCommand', error)
      }
      this.$emit('refreshListEffects')
    },
    async despuntearTransactionEffects(){
      if (this.canDespuntear){
        try {
          await new DespuntearTransactionEffectsCommand(sync_command_dispatcher, this).run(this.selectedTransactions.map(t => t.id))
        } catch (error) {
          console.error('Error while PuntearTransactionEffectsCommand', error)
        }
        this.snackbar.isVisible = true
        this.snackbar.text = 'Efectos despunteados de la transaccion'
        this.snackbar.color = 'success'
        this.$emit('refreshListEffects')
      }
    },
    get_effect_status(contrapartida) {
      for (let i in contrapartida) {
        if (contrapartida[i].kind == 'effect') {
          return true;
        }
      }
      return false;
    },
    isLoginas() {
      return this.userData && this.userData.hasOwnProperty('username') && this.session_information && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username);
    },
    saveFormat(new_format) {
      this.currentBankAccount.excel_format = new_format
      this.excel_format = new_format
    },
    async transferTransactions() {
      try {
        await new TransferTransactionsCommand(sync_command_dispatcher, this).run(this.selectedTransactions.map((x) => x.id), this.selectedBank)
      } catch (error) {
        console.error('Error while transferring transactions', error)
      }
    },
    async recalculateBalance() {
      let transaction_ids = this.selectedTransactions.map((x) => x.id)
      console.log('Recalculating balance for transactions:', transaction_ids)
      try {
        await new RecalculateBalanceCommand(sync_command_dispatcher, this).run(this.currentBankAccount.id, transaction_ids)
      } catch (error) {
        console.error('Error while recalculating balance', error)
      }
      await this.refreshListTransactions()
    },
    async downloadTransactionPDF(transactionID) {
      try {
        await new DownloadTransactionPDFCommand(async_command_dispatcher, this).run(transactionID, this.currentBankAccount.id)
      } catch (error) {
        console.error('Error while downloading transaction PDF', error)
        this.$set(this.downloadPDFJobStates, transactionID, 'error');
      }
    },
    async downloadTransactionPDFJobDone(transactionID) {
      let response = await jobs.getJob({ id: this.downloadPDFJobIds[transactionID] });
      this.$set(this.downloadPDFJobStates, transactionID, response.data.state);
      const success = response.data.output_info['success'];
      if (!success) {
        this.generic_error_msg = 'No se ha podido descargar el recibo de la transacción.'
        this.show_generic_error = true
      } else {
        let recived_url = response.data.output_info['pdf_url'];
        const res = await fetch(recived_url)
        const blob = await res.blob();
        const url = await URL.createObjectURL(blob)

        const a = document.createElement("a");
        a.href = url;
        a.download = 'transaction.pdf'
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    downloadTransactionPDFJobError(transactionID) {
      this.$set(this.downloadPDFJobStates, transactionID, 'error');
      this.generic_error_msg = 'Ha habido un error inesperado al intentar descargar el recibo de la transacción. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, contacte con soporte.'
      this.show_generic_error = true
    },
  },
  watch: {
    show_mismatch: {
      handler(newVal, oldVal) {
        if (newVal) {
          setTimeout(() => {
            const element = document.querySelector('.background_warning');
            /*if (element) {
              element.scrollIntoView();
            }*/
          }, 1000);
        }
      },
    },  
    limit(newVal) {
      localStorage.bank_items_per_page = newVal
    }
  },  
  async mounted() {
    if (localStorage.bank_items_per_page) {
      this.limit = Number(localStorage.bank_items_per_page)
    }
    //Filtro por defecto
    this.updateObject({'key':'state', 'value': 'not_done', 'text': 'No Contabilizado'})
    this.selectedTransactions = this.selectedTransactionsP    
    await new BankAccountList(query_dispatcher, this).run(this.currentCompany.id, this.$route.params.bank_account_id)
    await this.refreshBankAccount()
    try {
        await this.removeAllFilters({ skipStateFilter: true })
        await new BankAccountTransactions(query_dispatcher_2, this).run_filter(this.$route.params.bank_account_id, this.listFilters, this.$refs.bankSimpleFilters.option_selected, this.limit, this.offset)
    } catch (error) {
      console.error('Error get bank account transactions', error)
    }
    if (this.got_feature('feature_use_different_currencies_in_banks') && this.currentBankAccount && this.currentBankAccount.currency && !this.currentBankAccount.currency.includes('EUR')) {
      this.transactions_headers.splice(3, 0, {
                                                text: 'Importe',
                                                sortable: false,
                                                value: 'original_amount'
                                              })
      let index = this.transactions_headers.findIndex(obj => obj.value == 'amount')
      this.transactions_headers[index].text = 'Importe(EUR)'
    }    
    if (this.got_feature('feature_can_use_payable_or_receivable_effects') && this.currentBankAccount && this.workWithEffects) {
      this.transactions_headers.forEach((item) => {
        if (item.value == 'contrapartida') {
          item.width = 175
        }
      })
      try {
        await new GetEffectCounterpartListQuery(query_dispatcher, this).run(this.currentBankAccount.id)
      } catch (error) { 
        console.error(error)
      }
    }
    if (this.currentBankAccount.disconnected) {
      this.reconnectPopup = true;
    }
    if(this.currentCompany.companydb_type.value=='innuva') {
      await new ActivitiesQuery(query_dispatcher, this).run(this.currentCompany.id)
      await new ChannelsQuery(query_dispatcher, this).run(this.currentCompany.id)
    }
    if (!this.got_feature('feature_project_bank_counterpart')) { // remove 'analytics' header if feature not active
      let index = this.transactions_headers.findIndex(obj => obj.value == 'analytics')
      this.transactions_headers.splice(index, 1)
    }
    else { // feature active
      this.companyAnalyticEntities = await new GetAnalyticEntitiesQuery(query_dispatcher).run(this.currentCompany.id)
    }
    await new GetAvailableBanksQuery(query_dispatcher, this).run(this.$route.params.bank_account_id)
  }
}
</script>

<style scoped>
  .btn_counterpart {
    margin-right: 10px;
  }
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
  .bank-account-transactions-card {
    border-radius: 10px;
    box-shadow:none;
  }
  .bank-account-transactions-card.full-min-height {
    min-height: 100%;
  }
  .bank-account-transactions-card .v-card__title {
    font-size:20px;
    padding-top:20px;
    padding-bottom: 20px;
  }
  .bank-account-transactions-card .v-card__title .back_url span {
    font-size:13px;
  }
  .bank-account-transactions-card  .v-card__text {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
  }
  .bank-account-transactions-card  .v-card__text .container{
    padding:0px;
  }
  .bank-account-transactions-card >>> thead th {
    background-color: var(--v-primaryLight-base) !important;
    color: var(--v-primary-base) !important;
  }
  .bank-account-transactions-card >>> table tbody > tr:not(.v-data-table__expanded__content) > td:nth-child(1),
  .bank-account-transactions-card >>> table thead > tr > th:nth-child(1),
  .bank-account-transactions-card >>> table tbody > tr:not(.v-data-table__expanded__content) > td:nth-child(2),
  .bank-account-transactions-card >>> table thead > tr > th:nth-child(2),
  .bank-account-transactions-card >>> table tbody > tr:not(.v-data-table__expanded__content) > td:nth-child(3),
  .bank-account-transactions-card >>> table thead > tr > th:nth-child(3),
  .bank-account-transactions-card >>> table tbody > tr:not(.v-data-table__expanded__content) > td:nth-child(4),
  .bank-account-transactions-card >>> table thead > tr > th:nth-child(4) {
    padding: 0 5px !important; 
  }
  .bank-account-transactions-card >>> table tbody > tr > td,
  .bank-account-transactions-card >>> table thead > tr > th {
    padding: 0 10px !important;
    border-bottom: none !important;    
  }
  .bank-account-transactions-card >>> table tbody > tr > td:last-child,
  .bank-account-transactions-card >>> table thead > tr > th:last-child {
    padding-left: 0px !important;
  }

  .bank-account-transactions-card >>> table tbody > tr > td:nth-last-child(2),
  .bank-account-transactions-card >>> table thead > tr > th:nth-last-child(2) {
    padding-right: 0px !important;
  }
  .bank-account-transactions-card >>> td .v-input.v-text-field{
    font-size:14px;
    margin-top:0px;
  }
  .bank-account-transactions-card >>> td .v-input.v-text-field.left-input input{
    margin-left:0px;
  }
  .bank-account-transactions-card >>> tbody tr:nth-of-type(even) {
    background-color: #fafafa;
  }

  .bank-account-transactions-card td .btn-table-counterpart {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .bank-account-transactions-card td .btn-table-counterpart:hover {
    background-color: #bebcfd;
  }
  .bank-account-transactions-card td .btn-table-counterpart .v-icon {
    font-size: 14px;  
    width: 14px;
    height: 14px;
  }

  .bank-account-transactions-card >>> .v-data-table__expanded__content td{
    padding: 20px 0px !important
  }

  .bank-account-transactions-card >>> .v-data-table__expanded__content td.expanded-with-department{
    min-height: 120px !important;
    height: auto !important;
  }

  .bank-account-transactions-card .expandend-container .exp-field {
    padding-right: 30px;
    font-size:10px;
    font-weight: 300;
  }
  .bank-account-transactions-card .expandend-container .exp-field .exp-label {
    font-weight: 500;
    padding-bottom: 5px;
  }
  .bank-account-transactions-card >>> .v-data-table__wrapper {
    scrollbar-width: thin;
  }

  .bank-account-transactions-card .transactions-total-amount {
    position:absolute;
    margin-left:10px;
    bottom:30px;
    font-size: 12px;
  }
  .bank-account-transactions-card.full-min-height .transactions-total-amount {
    position:relative;
    margin-top:-30px;
    bottom:0px;
  }
  .bank-account-transactions-card .transactions-total-amount span {
    color:var(--v-primary-base);
    font-weight: bold;
  }

  .bank-account-transactions-card .btn-table-transaction {
    width:28px;
    height:28px;
    display:inline-flex;
    align-items: center;
    justify-content:center;    
    border-radius:50%;
    position:relative;
  }
  .bank-account-transactions-card .btn-table-transaction.btn-pointer {
    cursor:pointer;
  }
  .bank-account-transactions-card .btn-table-transaction .v-progress-circular {
    width:20px !important;
    height:20px !important;
  }

  .bank-account-transactions-card .btn-table-transaction:before {   
    border-radius: inherit;
    bottom: 0;
    color: inherit;
    content: "";
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }

  .bank-account-transactions-card .btn-table-transaction:hover:before {
    opacity: 0.08;
    background-color:var(--v-primary-base)
  }


  .font-40 {
    font-size:40px !important;
  }  
  .min-160 {
    min-width: 160px;
  }
  .progress_circular {
    display: inline-block;
  }

  .progress_circle {
    height: 26px !important;
    width: 26px !important;
    margin-right: 5px;
  }
  .text-right {
    text-align: right !important;
  }

  .v-card__actions {
    padding: 0 34px 20px !important;
  }

  .v-input__slot {
    margin-bottom: 0px !important;
  }

  .v-input--selection-controls,
  .app-col--no-input-fields-inside {
    margin-top: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px!important;
  }
  
  .currency {
    border: 0.5px solid #565656;
    border-radius: 10px;
    padding: 2px 5px;
    font-weight: 300;
    color: #565656;
  }

  .light__header {
    color: #565656;
    font-weight: 300;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .square-icon-text {
    text-align: center;
    width:16px;
    height: 16px;
    border-radius:5px;
  }

  .lg-square-icon-text {
    text-align: center;
    width:21px;
    height: 21px;
    border-radius:5px;
  }

  .orange-icon {
    background-color:#F7BC25;
  }

  .red-icon {
    background-color: #F36C0B;
  }

  .primary-icon {
    background-color: var(--v-primary-base);
  }

  .icon-16 {
    font-size:16px;
  }

  .background_warning {
    background: rgba(255, 133, 51, 0.15) !important;
  }

  .background_warning__expended {
    background: rgba(255, 133, 51, 0.10) !important;
  }
  .color-group-even {
    background: rgba(255, 196, 196, 0.4) !important;
  }
  .color-group-even__expanded {
    background: rgba(255, 196, 196, 0.3) !important;
  }
  .color-group-odd {
    background: rgba(255, 253, 197, 0.6)  !important;
  }
  .color-group-odd__expanded {
    background: rgba(255, 253, 197, 0.4) !important;
  }

  .counterpart_kind.v-text-field >>> .v-input__control>.v-input__slot:before { 
    border-style: none; 
  } 
  .counterpart_kind.v-text-field >>> .v-input__control>.v-input__slot:after { 
    border-style: none; 
  }
  .counterpart_kind.v-text-field.v-text-field--enclosed .v-input__slot {
    padding: 0;
  }

  .counterpart_kind.v-select .v-select__selections input {
    display: none;
  }

  .counterpart_kind.v-select .v-select__selections  {
    padding: 0 !important;
  }

  .counterpart_kind.v-text-field {
    padding: 0 !important;
  }

  .v-select__selection.v-select__selection--comma {
    max-width: 100% !important;
    margin-right: 0 !important;
  }

  /* input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  } */  
  .text__switch {
    font-size: 11px;
    font-weight: 800;
  }

  .swicth_counterpart {
    border-radius: 14px;
    border: 1px solid #DFDFDF;
    background-color: transparent !important;
    box-shadow: none !important;
    height: 24px !important;
    width: 40px !important;
    text-transform: none !important;
  }

  .swicth_counterpart .v-btn__content {
    display: flex !important;
    align-items: center !important;
  }

  .swicth_counterpart.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent !important;
  }
  .btn-switch_counterpart {
    border-radius: 14px;
    border: 1px solid #DFDFDF;    
    box-shadow: none !important;
    height: 24px !important;
    width: 40px !important;
    text-transform: none !important;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
  }
  .btn-switch_counterpart.disabled {
    cursor:default
  }

  .counterpart__field__with__effect {
    width: 140px !important;
  }

  .default-acccount-effects-input >>> .counterpart {
    border-bottom: 1px solid var(--v-primary-base);
    border-radius: 0px;
  }
</style>

<style>
.background_warning {
  background: rgba(255, 133, 51, 0.15) !important;
}

.background_warning__expended {
  background: rgba(255, 133, 51, 0.10) !important;
}

.color-group-even {
  background: rgba(255, 196, 196, 0.4) !important;
}
.color-group-even__expanded {
  background: rgba(255, 196, 196, 0.3) !important;
}

.color-group-odd {
  background: rgba(255, 253, 197, 0.6)  !important;
}
.color-group-odd__expanded {
  background: rgba(255, 253, 197, 0.4) !important;
}

.text_readonly {
  color: #CCCBCB;
}
</style>

<style lang="scss">
.upload__header {
  display: flex !important;
  height: 70px !important;
  padding: 24px 42px 24px 48px !important;
  justify-content: space-between !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  align-self: stretch !important;
  border-radius: 24px 24px 0 0 !important;
  border: 1px solid var(--Neutral-150, #E7E7E7) !important;
  background: var(--White, #FFF) !important;

  .upload__header-left {
    display: flex !important;
    align-items: baseline !important;
    gap: 6px !important;

    .upload__title {
      color: var(--v-primary-base) !important;
      font-family: Roboto !important;
      font-size: 20px !important;
      font-weight: 700 !important;
      line-height: normal !important;
    }

    .upload__subtitle {
      color: var(--v-primary-base) !important;
      font-family: Roboto !important;
      font-size: 20px !important;
      font-weight: 400 !important;
      line-height: normal !important;
      flex: 0 1 auto !important;
    }
  }

  .upload__close {
    background: none !important;
    border: none !important;
    cursor: pointer !important;
    color: var(--v-primary-base) !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    line-height: 1 !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}

.upload__body {
  padding: 32px 97px 87px 130px !important;
  box-sizing: border-box !important;

  .upload__content {
    display: flex !important;
    width: 557px !important;
    height: 366px !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 32px !important;
    flex-shrink: 0 !important;

    .upload__content-inner {
      display: flex !important;
      flex-direction: column !important;
      gap: 24px !important;
      width: 100% !important;
      padding: 32px !important;
      box-sizing: border-box !important;
    }
  }
}

.form__group {
  margin-top: 16px !important;
}

.form__group--gap {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 4px !important;
}

.form__label {
  color: #565656 !important;
  font-family: Roboto !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: normal !important;
  margin-bottom: 4px !important;
}

.form__box {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  min-height: 40px !important;
  border: 1px solid #D6D6D6 !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
  width: 100% !important;

  .form__text {
    color: var(--Neutral-700, #4F4F4F) !important;
    font-family: Roboto !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
    text-transform: capitalize !important;
  }
}

.theme--light.v-select .v-select__selection--comma {
  color: #4F4F4F !important;
  font-family: Roboto !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  text-transform: capitalize !important;
}

.form__select {
  display: flex !important;
  width: 327.441px !important;
  height: 20px !important;
  flex-direction: column !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  color: #4F4F4F !important;
  font-family: Roboto !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  text-transform: capitalize !important;
}

.form__file {
  display: flex !important;
  width: 390px !important;
  flex-direction: column !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  font-family: Roboto !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  letter-spacing: -0.12px !important;

  .v-file-input__text--placeholder {
    color: #4F4F4F !important;
    font-family: Roboto !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
    text-transform: capitalize !important;
  }
}

.form__file-icon {
  color: #7339b7 !important;
}

.form__config-row {
  margin-top: 8.5px !important;
  display: flex !important;
  justify-content: flex-end !important;
  width: 100% !important;
}

.upload__actions {
  display: flex;
  padding: 8px;
  flex-direction: row;
  justify-content: flex-end;
  
  .v-btn.v-btn {
    display: flex;
    width: 102px;
    height: 43px;
    padding: 8px 8px 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 8px;
    background: #7339B7;

    .v-btn__content {
      width: 62px;
      position: absolute;
      left: 20px;
      top: 12.5px;
      color: var(--v-neutral-base);
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
}

.bank-account-header {
  display: flex;
  flex-direction: row;
  margin: 0;
  align-items: center;
}

.subheader-container {

  display: flex;
  flex-direction: row;
  gap: 4px;

  .static-text {
    color: #4F4F4F;      
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }

  .dinamic-text {
    color: #6D6D6D;       
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }
}

.upload__content__subheader{
  display: flex;
  width: 431px;
  height: 26px;
  flex-direction: row;
  justify-content: flex-start;
  flex-shrink: 0;
  color: #565656;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  gap: 4px;
  padding: 0;
}
</style>

